
<template>
    <div>
        <sp-select 
        theme="team" 
        :required="true"
        v-model="finaldomain"
        :options="domain"
        :selected="selecteddomain"
        name="domain-activity" 
        id="domain-activity" placeholder="Domaine d'activité"
        :label="$t('company.activity_domain')"
        class="mb-5">
        </sp-select>

        <sp-select
        theme="team" 
        v-if="sector.length>0"
        :required="true"
        :label="$t('company.sector')" 
        v-model="finalsector" 
        :options="sector" 
        :selected="selectedsector"
        name="sector" 
        id="sector" placeholder="Secteur"
        class="mb-5">
        </sp-select>

        <sp-select
        v-if="first_level_activity.length>0"
        theme="team" 
        :required="true"
        :label="$t('company.first_level_activity')" 
        v-model="firstLevel" 
        :options="first_level_activity"
        :selected="selectedFirstLevel"
        name="first_level_activity" 
        id="first_level_activity" placeholder="Activité"
        class="mb-5">
        </sp-select>

        <sp-select
        v-if="second_level_activity.length>0"
        theme="team" 
        :required="true"
        :label="$t('company.second_level_activity')" 
        v-model="secondLevel" 
        :options="second_level_activity"
        :selected="selectedSecondLevel"
        name="second_level_activity" 
        id="second_level_activity" placeholder="Activité"
        class="mb-5">
        </sp-select>

        <sp-select
        v-if="three_level_activity.length>0"
        theme="team" 
        :required="true"
        :label="$t('company.three_level_activity')" 
        v-model="threeLevel" 
        :options="three_level_activity"
        :selected="selectedThreeLevel"
        name="three_level_activity" 
        id="three_level_activity" placeholder="Activité"
        class="mb-5">
        </sp-select>

        <sp-select
        v-if="four_level_activity.length>0"
        theme="team" 
        :required="true"
        :label="$t('company.four_level_activity')" 
        v-model="fourLevel" 
        :options="four_level_activity"
        :selected="selectedFourLevel"
        name="four_level_activity" 
        id="four_level_activity" placeholder="Activité"
        class="mb-5">
        </sp-select>

    </div>
</template>

<script>
import SelectVue from './Select.vue';
export default {
    name: "sp-activity-list",
    components:{
        "sp-select": SelectVue
    },
    props:{
        selecteddomain:{
            required:false,
            type: String,
            default: null
        },
        selectedsector:{
            required:false,
            type: String,
            default: null
        },
        selectedFirstLevel:{
            required:false,
            type: String,
            default: null
        },
        selectedSecondLevel:{
            required:false,
            type: String,
            default: null
        },
        selectedThreeLevel:{
            required:false,
            type: String,
            default: null
        },
        selectedFourLevel:{
            required:false,
            type: String,
            default: null
        },
        edited:{
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch:{
        finaldomain(val){
            if(val && this.edited==false){
                let keysSectors = Object.keys(this.data[val]);
                this.sector = [];
                this.first_level_activity = [];
                this.second_level_activity = [];
                this.three_level_activity = [];
                this.four_level_activity = [];
                let i=0;
                Array.prototype.forEach.call(keysSectors, key => {                 
                    this.sector.push({"name":key,"value" :i});
                    i++;
                });
                this.$emit("select-change",['domain', val]);
            }

        }, 
        finalsector(val){
            if(val && this.edited==false){
                this.first_level_activity = [];
                this.second_level_activity = [];
                this.three_level_activity = [];
                this.four_level_activity = [];
                let i=0;
                Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][val]), key => {

                    this.first_level_activity.push({"name":key,"value" :i});
                     i++;
                });
                this.$emit("select-change",['sector', val]);
            }

        },
        firstLevel(val){
            if(val && this.edited==false){
                this.second_level_activity = [];
                this.three_level_activity = [];
                this.four_level_activity = [];
                let i=0;
                Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][this.finalsector][val]), key => {
                    this.second_level_activity.push({"name":key,"value" :i});
                     i++;
                });
                this.$emit("select-change",['first_level_activity', val]);
            }

        },
        secondLevel(val){
            if(val && this.edited==false){
                this.three_level_activity = [];
                this.four_level_activity = [];
                let i=0;
                Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][this.finalsector][this.firstLevel][val]), key => {
                    this.three_level_activity.push({"name":key,"value" :i});
                     i++;
                });
                this.$emit("select-change",['second_level_activity', val]);
            }

        },
        threeLevel(val){
            if(val && this.edited==false){
                this.four_level_activity = [];
                let i=0;
                Array.prototype.forEach.call(this.data[this.finaldomain][this.finalsector][this.firstLevel][this.secondLevel][val], key => {
                    this.four_level_activity.push({"name":key,"value" :i});
                     i++;
                });
                this.$emit("select-change",['three_level_activity', val]);
            }
            this.$emit("edit-change-act",false);

        },
        fourLevel(val){
            this.$emit("select-change",['four_level_activity', val]);
        },
        selecteddomain(val){
            this.finaldomain=val;
            let keysSectors = Object.keys(this.data[val]);
            this.sector = [];
            this.first_level_activity = [];
            this.second_level_activity = [];
            this.three_level_activity = [];
            this.four_level_activity = [];
            let i=0;
            Array.prototype.forEach.call(keysSectors, key => {
                this.sector.push({"name":key,"value" :i});
                i++;
            });
        },
        selectedsector(val){
            this.finalsector=val;
            this.first_level_activity = [];
            this.second_level_activity = [];
            this.three_level_activity = [];
            this.four_level_activity = [];
            let i=0;
            Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][val]), key => {
                this.first_level_activity.push({"name":key,"value" :i});
                i++;
            });
        },
        selectedFirstLevel(val){
            this.firstLevel=val;
            this.second_level_activity = [];
            this.three_level_activity = [];
            this.four_level_activity = [];
            let i=0;
            Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][this.finalsector][val]), key => {
                this.second_level_activity.push({"name":key,"value" :i});
                i++;
            });
        },
        selectedSecondLevel(val){
            this.secondLevel=val;
            this.three_level_activity = [];
            this.four_level_activity = [];
            let i=0;
            Array.prototype.forEach.call(Object.keys(this.data[this.finaldomain][this.finalsector][this.firstLevel][val]), key => {
                this.three_level_activity.push({"name":key,"value" :i});
                i++;
            });
        },
        selectedThreeLevel(val){
            this.threeLevel=val;
            this.four_level_activity = [];
            let i=0;
            Array.prototype.forEach.call(this.data[this.finaldomain][this.finalsector][this.firstLevel][this.secondLevel][val], key => {
                this.four_level_activity.push({"name":key,"value" :i});
                i++;
            });
        }
    },
    data() {
        return {
            finaldomain:null,
            finalsector:null,
            firstLevel:null, 
            secondLevel:null,   
            threeLevel:null, 
            fourLevel:null, 
            sector:[],
            first_level_activity:[],
            second_level_activity:[],
            three_level_activity:[],
            four_level_activity:[],
            "domain":[
                { "name" :"AGRICULTURE, CHASSE, SYLVICULTURE","value" : "1"},
                { "name" :"PECHE, PISCICULTURE ET AQUACULTURE","value" : "2"},
                { "name" :"INDUSTRIES EXTRACTIVES","value" : "3"},
                { "name" :"INDUSTRIE MANUFACTURIERE","value" : "4"},
                { "name" :"PRODUCTION ET DISTRIBUTION D'ELECTRICITE, DE GAZ ET D'EAU","value" : "5"},
                { "name" :"CONSTRUCTION","value" : "6"},
                { "name" :"COMMERCE; REPARATIONS AUTOMOBILE ET D'ARTICLES DOMESTIQUES","value" : "7"},
                { "name" :"HOTELS ET RESTAURANTS","value" : "8"},
                { "name" :"TRANSPORTS ET COMMUNICATIONS","value" : "9"},
                { "name" :"ACTIVITES FINANCIERES","value" : "10"},
                { "name" :"IMMOBILIER, LOCATIONS ET SERVICES AUX ENTREPRISES","value" : "11"},
                { "name" :"ADMINISTRATION PUBLIQUE","value" : "12"},
                { "name" :"EDUCATION","value" : "13"},
                { "name" :"SANTE ET ACTION SOCIALE","value" : "14"},
                { "name" :"SERVICES COLLECTIFS, SOCIAUX ET PERSONNELS","value" : "15"},
                { "name" :"SERVICES DOMESTIQUES","value" : "16"},
                { "name" :"ORGANISMES EXTRA-TERRITORIAUX","value" : "17"}
            ],
            "data": {
                "AGRICULTURE, CHASSE, SYLVICULTURE": {
                    "AGRICULTURE, CHASSE, SYLVICULTURE": {
                        "AGRICULTURE, CHASSE, SERVICES ANNEXES":{
                            "CULTURE":{
                                "CULTURE DE CEREALES; CULTURES INDUSTRIELLES" :[
                                    "CULTURE DE CEREALES",
                                    "CULTURE DE FOURRAGES",
                                    "CULTURE DE LEGUMINEUSES ET CULTURES INDUSTRIELLES"
                                    
                                ],
                                "CULTURE DE LEGUMES; HORTICULTURE; PEPINIERES":[
                                    "CULTURE DE LEGUMES; MARAICHAGE",
                                    "HORTICULTURE; PEPINIERES"
                                ],
                                "CULTURE DE FRUITS, DE PLANTES POUR BOISSONS ET POUR EPICES":[
                                    "CULTURE D'AGRUMES ET VERGERS",
                                    "CULTURE D'OLIVIERS",
                                    "CULTURE DE PALMIERS-DATTIERS",
                                    "VITICULTURE"
                                ]
                            },
                            "ELEVAGE":{
                                "ELEVAGE DE BOVINS, PRODUCTION DE LAIT A LA FERME" :[
                                    "ELEVAGE DE BOVINS, PRODUCTION DE LAIT A LA FERME"
                                ],
                                "ELEVAGE D'OVINS, CAPRINS ET EQUIDES" :[
                                    "ELEVAGE D'OVINS ET DE CAPRINS",
                                    "ELEVAGE D'EQUIDES"
                                ],
                                "ELEVAGE DE PORCINS" :[
                                    "ELEVAGE DE PORCINS"
                                ],
                                "ELEVAGE DE VOLAILLES" :[
                                    "ELEVAGE DE VOLAILLES"
                                ],
                                "ELEVAGE D'AUTRES ANIMAUX" :[
                                    "ELEVAGE DE CAMELIDES",
                                    "ELEVAGE D'ANIMAUX N.C.A"
                                ]
                            },
                            "CULTURE ET ELEVAGE ASSOCIES":{
                                "CULTURE ET ELEVAGE ASSOCIES" :[
                                   "CULTURE ET ELEVAGE ASSOCIES"
                                ]
                            },
                            "ACTIVITES DES SERVICES ANNEXES A L'AGRICULTURE, SAUF ACTIVITES VETERINAIRES":{
                                "ACTIVITES DES SERVICES ANNEXES A LA CULTURE" :[
                                   "ACTIVITES DE SERVICES AUX CULTURES PRODUCTIVES",
                                   "REALISATION ET ENTRETIEN DE PLANTATIONS ORNEMENTALES"
                                ],
                                "ACTIVITES DE SERVICES ANNEXES A L'ELEVAGE, SAUF ACTIVITES VETERINAIRES" :[
                                    "ACTIVITES DE SERVICES ANNEXES A L'ELEVAGE, SAUF ACTIVITES VETERINAIRES"
                                ]
                            },
                            "CHASSE, PIEGEAGE, REPEUPLEMENT EN GIBIER ET ACTIVITES DES SERVICES ANNEXES":{
                                "CHASSE, PIEGEAGE, REPEUPLEMENT EN GIBIER ET ACTIVITES DES SERVICES ANNEXES" :[
                                   "CHASSE, PIEGEAGE, REPEUPLEMENT EN GIBIER ET ACTIVITES DES SERVICES ANNEXES"
                                ]
                            }
                        },
                        "SYLVICULTURE, EXPLOITATION FORESTIERE, SERVICES ANNEXES":{
                            "SYLVICULTURE, EXPLOITATION FORESTIERE ET ACTIVITES DES SERVICES ANNEXES":{
                                "SYLVICULTURE, EXPLOITATION FORESTIERE" :[
                                    "SYLVICULTURE",
                                    "RECOLTE DE L'ALFA",
                                    "RECOLTE DU LIEGE",
                                    "EXPLOITATION FORESTIERE"
                                ],
                                "ACTIVITES DES SERVICES ANNEXES A LA SYLVICULTURE ET AUX EXPLOITATIONS FORESTIERES":[
                                    "ACTIVITES DES SERVICES ANNEXES A LA SYLVICULTURE ET AUX EXPLOITATIONS FORESTIERES"
                                ]
                            }
                        }
                    }
                },
                "PECHE, PISCICULTURE ET AQUACULTURE":{
                    "PECHE, PISCICULTURE ET AQUACULTURE":{
                        "PECHE, PISCICULTURE ET AQUACULTURE":{
                            "PECHE, PISCICULTURE ET AQUACULTURE":{
                                "PECHE":[
                                    "PECHE"
                                ],
                                "PISCICULTURE ET AQUACULTURE":[
                                    "PISCICULTURE ET AQUACULTURE"
                                ]
                            }
                        }
                    }
                },
                "INDUSTRIES EXTRACTIVES":{
                    "EXTRACTION DE PRODUITS ENERGETIQUES":{
                        "EXTRACTION DE HOUILLE, DE LIGNITE ET DE TOURBE":{
                            "EXTRACTION ET AGGLOMERATION DE LA HOUILLE":{
                                "EXTRACTION ET AGGLOMERATION DE LA HOUILLE":[
                                    "EXTRACTION ET AGGLOMERATION DE LA HOUILLE"
                                ]
                            },
                            "EXTRACTION ET AGGLOMERATION DU LIGNITE":{
                                "EXTRACTION ET AGGLOMERATION DU LIGNITE":[
                                    "EXTRACTION ET AGGLOMERATION DU LIGNITE"
                                ]
                            },
                            "EXTRACTION ET AGGLOMERATION DE LA TOURBE":{
                                "EXTRACTION ET AGGLOMERATION DE LA TOURBE":[
                                    "EXTRACTION ET AGGLOMERATION DE LA TOURBE"
                                ]
                            }

                        },
                        "EXTRACTION D'HYDROCARBURES; ACTIVITES DES SERVICES ANNEXES":{
                            "EXTRACTION D'HYDROCARBURES":{
                                "EXTRACTION D'HYDROCARBURES":[
                                    "EXTRACTION DE PETROLE BRUT ET DU GAZ",
                                    "LIQUEFACTION DE GAZ NATUREL"
                                ]
                            },
                            "ACTIVITES DE SERVICES ANNEXES A L'EXTRACTION D'HYDROCARBURES":{
                                "ACTIVITES DE SERVICES ANNEXES A L'EXTRACTION D'HYDROCARBURES":[
                                    "FORAGES D'HYDROCARBURES POUR COMPTE DE TIERS",
                                    "AUTRES ACTIVITES DE SERVICES ANNEXES A L'EXPLOITATION DE GISEMENTS D'HYDROCARBURES"
                                ]
                            }
                        },
                        "EXTRACTION DE MINERAIS D'URANIUM":{
                            "EXTRACTION DE MINERAIS D'URANIUM":{
                                "EXTRACTION DE MINERAIS D'URANIUM":[
                                    "EXTRACTION DE MINERAIS D'URANIUM"
                                ]
                            }
                        }
                    },
                    "EXTRACTION DE PRODUITS NON ENERGETIQUES":{
                        "EXTRACTION DE MINERAIS METALLIQUES":{
                            "EXTRACTION DE MINERAIS DE FER":{
                                "EXTRACTION DE MINERAIS DE FER":[
                                    "EXTRACTION DE MINERAIS DE FER"
                                ]
                            },
                            "EXTRACTION DE MINERAIS DE METAUX NON FERREUX":{
                                "EXTRACTION DE MINERAIS DE METAUX NON FERREUX":[
                                    "EXTRACTION DE MINERAIS DE METAUX NON FERREUX"
                                ]
                            }

                        },
                        "AUTRES INDUSTRIES EXTRACTIVES":{
                            "EXTRACTION DE PIERRES":{
                                "EXTRACTION DE PIERRES POUR LA CONSTRUCTION":[
                                    "EXTRACTION DE PIERRES POUR LA CONSTRUCTION"
                                ],
                                "EXTRACTION DE CALCAIRE INDUSTRIEL, DE GYPSE ET DE CRAIE":[
                                    "EXTRACTION DE CALCAIRE INDUSTRIEL, DE GYPSE ET DE CRAIE"
                                ],
                                "EXTRACTION D'ARDOISE":[
                                    "EXTRACTION D'ARDOISE"
                                ]
                            },
                            "EXTRACTION DE SABLES ET D'ARGILES":{
                                "EXTRACTION DE SABLES ET DE GRANULATS":[
                                    "EXTRACTION DE SABLES ET DE GRANULATS"
                                ],
                                "EXTRACTION D'ARGILES ET DE KAOLIN":[
                                    "EXTRACTION D'ARGILES ET DE KAOLIN"
                                ]
                            },
                            "EXTRACTION DE MINERAUX POUR L'INDUSTRIE CHIMIQUE ET D'ENGRAIS NATURELS":{
                                "EXTRACTION DE MINERAUX POUR L'INDUSTRIE CHIMIQUE ET D'ENGRAIS NATURELS":[
                                    "EXTRACTION DE PHOSPHATES NATURELS",
                                    "EXTRACTION D'AUTRES MINERAUX POUR L'INDUSTRIE CHIMIQUE"
                                ]
                            },
                            "PRODUCTION DE SEL":{
                                "PRODUCTION DE SEL":[
                                    "PRODUCTION DE SEL"
                                ]
                            },
                            "AUTRES ACTIVITES EXTRACTIVES N.C.A":{
                                "AUTRES ACTIVITES EXTRACTIVES N.C.A.":[
                                    "AUTRES ACTIVITES EXTRACTIVES N.C.A."
                                ]
                            }
                        }
                    }
                
                },
                "INDUSTRIE MANUFACTURIERE":{
                    "INDUSTRIES AGRICOLES ET ALIMENTAIRES":{
                        "INDUSTRIES ALIMENTAIRES":{
                            "INDUSTRIE DES VIANDES":{
                                "PRODUCTION DE VIANDES DE BOUCHERIE":[
                                    "PRODUCTION DE VIANDES DE BOUCHERIE"
                                ],
                                "PRODUCTION DE VIANDES DE VOLAILLES ET DE LAPINS":[
                                    "PRODUCTION DE VIANDES DE VOLAILLES ET DE LAPINS"
                                ],
                                "PREPARATION DE PRODUITS A BASE DE VIANDES DE BOUCHERIE ET DE VOLAILLES":[
                                    "PREPARATION DE PRODUITS A BASE DE VIANDES DE BOUCHERIE ET DE VOLAILLES"
                                ]
                            },
                            "INDUSTRIE DU POISSON":{
                                "TRANSFORMATION ET CONSERVATION DU POISSON ET DES PRODUITS A BASE DE POISSONS":[
                                    "TRANSFORMATION ET CONSERVATION DU POISSON ET DES PRODUITS A BASE DE POISSONS"
                                ]
                            },
                            "INDUSTRIE DES FRUITS ET LEGUMES":{
                                "TRANSFORMATION ET CONSERVATION DE POMMES DE TERRE":[
                                    "TRANSFORMATION ET CONSERVATION DE POMMES DE TERRE"
                                ],
                                "PREPARATION DE JUS DE FRUITS ET LEGUMES":[
                                    "PREPARATION DE JUS DE FRUITS ET LEGUMES"
                                ],
                                "TRANSFORMATION ET CONSERVATION DE FRUITS ET LEGUMES N.C.A.":[
                                    "TRANSFORMATION ET CONSERVATION DE TOMATES",
                                    "TRANSFORMATION ET CONSERVATION D'AUTRES LEGUMES, SAUF TOMATES",
                                    "TRANSFORMATION ET CONSERVATION DE FRUITS"
                                ]
                            },
                            "INDUSTRIE DES HUILES ET DES CORPS GRAS":{
                                "FABRICATION D'HUILES ET GRAISSES BRUTES":[
                                    "FABRICATION D'HUILES ET GRAISSES BRUTES"
                                ],
                                "FABRICATION D'HUILES ET GRAISSES RAFFINEES":[
                                    "FABRICATION D'HUILES D'OLIVES",
                                    "FABRICATION D'AUTRES HUILES ET GRAISSES RAFFINEES"
                                ],
                                "FABRICATION DE MARGARINE":[
                                    "FABRICATION DE MARGARINE"
                                ]
                            },
                            "INDUSTRIE LAITIERE":{
                                "FABRICATION DE PRODUITS LAITIERS ET DE FROMAGES":[
                                    "FABRICATION DE PRODUITS LAITIERS ET DE FROMAGES"
                                ],
                                "FABRICATION DE GLACES ET SORBETS":[
                                    "FABRICATION DE GLACES ET SORBETS"
                                ]
                            },
                            "TRAVAIL DES GRAINS, FABRICATION DE PRODUITS AMYLACES":{
                                "TRAVAIL DES GRAINS":[
                                    "MEUNERIE",
                                    "AUTRES ACTIVITES DE TRAVAIL DES GRAINS"
                                ],
                                "FABRICATION DE PRODUITS AMYLACES":[
                                    "FABRICATION DE PRODUITS AMYLACES"
                                ]
                            },
                            "FABRICATION D'ALIMENTS POUR ANIMAUX":{
                                "FABRICATION D'ALIMENTS POUR ANIMAUX DE FERME":[
                                    "FABRICATION D'ALIMENTS POUR ANIMAUX DE FERME"
                                ],
                                "FABRICATION D'ALIMENTS POUR ANIMAUX DE COMPAGNIE":[
                                    "FABRICATION D'ALIMENTS POUR ANIMAUX DE COMPAGNIE"
                                ]
                            },
                            "AUTRES INDUSTRIES ALIMENTAIRES":{
                                "BOULANGERIE ET BOULANGERIE-PATISSERIE":[
                                    "BOULANGERIE ET BOULANGERIE-PATISSERIE",
                                    "PATISSERIE (EXCLUSIVE)"
                                ],
                                "BISCOTTERIE, BISCUITERIE, PATISSERIE DE CONSERVATION":[
                                    "BISCOTTERIE, BISCUITERIE, PATISSERIE DE CONSERVATION"
                                ],
                                "FABRICATION DE SUCRE":[
                                    "FABRICATION DE SUCRE"
                                ],
                                "CHOCOLATERIE, CONFISERIE":[
                                    "CHOCOLATERIE, CONFISERIE"
                                ],
                                "FABRICATION DE PATES ALIMENTAIRES ET DE COUSCOUS":[
                                    "FABRICATION DE PATES ALIMENTAIRES ET DE COUSCOUS"
                                ],
                                "TRANSFORMATION  DU CAFE ET DU THE":[
                                    "TRANSFORMATION  DU CAFE ET DU THE"
                                ],
                                "FABRICATION DE CONDIMENTS ET ASSAISONNEMENTS":[
                                    "FABRICATION DE CONDIMENTS ET ASSAISONNEMENTS"
                                ],
                                "FABRICATION D'ALIMENTS ADAPTES A L'ENFANT ET DIETETIQUES":[
                                    "FABRICATION D'ALIMENTS ADAPTES A L'ENFANT ET DIETETIQUES"
                                ],
                                "INDUSTRIES ALIMENTAIRES N.C.A.":[
                                    "INDUSTRIES ALIMENTAIRES N.C.A."
                                ]
                            },
                            "INDUSTRIE DES BOISSONS":{
                                "PRODUCTION DE BOISSONS ALCOOLIQUES DISTILLEES":[
                                    "PRODUCTION DE BOISSONS ALCOOLIQUES DISTILLEES"
                                ],
                                "PRODUCTION D'ALCOOL ETHYLIQUE DE FERMENTATION":[
                                    "PRODUCTION D'ALCOOL ETHYLIQUE DE FERMENTATION"
                                ],
                                "PRODUCTION DE VIN":[
                                    "PRODUCTION DE VIN"
                                ],
                                "CIDRERIE ET FABRICATION DE VINS D'AUTRES FRUITS":[
                                    "CIDRERIE ET FABRICATION DE VINS D'AUTRES FRUITS"
                                ],
                                "PRODUCTION D'AUTRES BOISSONS FERMENTEES NON DISTILLEES":[
                                    "PRODUCTION D'AUTRES BOISSONS FERMENTEES NON DISTILLEES"
                                ],
                                "BRASSERIE":[
                                    "BRASSERIE"
                                ],
                                "MALTERIE":[
                                    "MALTERIE"
                                ],
                                "INDUSTRIE DES EAUX MINERALES ET DES BOISSONS RAFRAICHISSANTES SANS ALCOOL":[
                                    "INDUSTRIE DES EAUX DE TABLE",
                                    "PRODUCTION DE BOISSONS RAFRAICHISSANTES"
                                ]
                            },
                            
                        },
                        "INDUSTRIE DU TABAC":{
                            "INDUSTRIE DU TABAC":{
                                "INDUSTRIE DU TABAC":[
                                    "INDUSTRIE DU TABAC"
                                ]
                            },
                        }
                    },
                    "INDUSTRIE TEXTILE ET HABILLEMENT":{
                        "INDUSTRIE TEXTILE":{
                            "FILATURE":{
                                "PREPARATION ET FILATURE DE L'INDUSTRIE COTONNIERE":[
                                    "PREPARATION ET FILATURE DE L'INDUSTRIE COTONNIERE"
                                ],
                                "PREPARATION ET FILATURE DE L'INDUSTRIE LAINIERE-CYCLE CARDE":[
                                    "PREPARATION ET FILATURE DE L'INDUSTRIE LAINIERE-CYCLE CARDE"
                                ],
                                "PREPARATION ET FILATURE DE L'INDUSTRIE LAINIERE-CYCLE PEIGNE":[
                                    "PREPARATION ET FILATURE DE L'INDUSTRIE LAINIERE-CYCLE PEIGNE"
                                ],
                                "PREPARATION ET FILATURE DU LIN":[
                                    "PREPARATION ET FILATURE DU LIN"
                                ],
                                "MOULINAGE ET TEXTURATION DE LA SOIE ET DES TEXTILES ARTIFICIELS ET SYNTHETIQUES":[
                                    "MOULINAGE ET TEXTURATION DE LA SOIE ET DES TEXTILES ARTIFICIELS ET SYNTHETIQUES"
                                ],
                                "FABRICATION DE FILS A COUDRE":[
                                    "FABRICATION DE FILS A COUDRE"
                                ],
                                "PREPARATION ET FILATURE DE JUTE ET D'AUTRES FIBRES DURES":[    
                                    "PREPARATION ET FILATURE DE JUTE ET D'AUTRES FIBRES DURES"
                                ]
                            },
                            "TISSAGE":{
                                "TISSAGE DE L'INDUSTRIE COTONNIERE":[
                                    "TISSAGE DE L'INDUSTRIE COTONNIERE"
                                ],
                                "TISSAGE DE L'INDUSTRIE LAINIERE-CYCLE CARDE":[
                                    "TISSAGE DE L'INDUSTRIE LAINIERE-CYCLE CARDE"
                                ],
                                "TISSAGE DE L'INDUSTRIE LAINIERE-CYCLE PEIGNE":[
                                    "TISSAGE DE L'INDUSTRIE LAINIERE-CYCLE PEIGNE"
                                ],
                                "TISSAGE DE SOIERIES":[
                                    "TISSAGE DE SOIERIES"
                                ],
                                "TISSAGE D'AUTRES TEXTILES":[
                                    "TISSAGE D'AUTRES TEXTILES"
                                ]
                            },
                            "ENNOBLISSEMENT TEXTILE":{
                                "ENNOBLISSEMENT TEXTILE":[
                                    "ENNOBLISSEMENT TEXTILE"
                                ]
                            },
                            "FABRICATION D'ARTICLES TEXTILES":{
                                "FABRICATION D'ARTICLES TEXTILES":[
                                    "FABRICATION DE COUVERTURES",
                                    "FABRICATION DE LINGES DOMESTIQUES DIVERS",
                                    "FABRICATION D'AUTRES ARTICLES CONFECTIONNES EN TEXTILE",
                                    "FABRICATION ARTISANALE D'ARTICLES TEXTILES TRADITIONNELS"
                                ]
                            },
                            "AUTRES INDUSTRIES TEXTILES":{
                                "FABRICATION DE TAPIS ET MOQUETTES":[
                                    "FABRICATION INDUSTRIELLE DE TAPIS ET MOQUETTES",
                                    "FABRICATION ARTISANALE DE TAPIS"
                                ],
                                "FICELLERIE, CORDERIE, FABRICATION DE FILETS":[
                                    "FICELLERIE, CORDERIE, FABRICATION DE FILETS"
                                ],
                                "FABRICATION DE NON-TISSES":[
                                    "FABRICATION DE NON-TISSESs"
                                ],
                                "INDUSTRIES TEXTILES N.C.A.":[
                                    "INDUSTRIES TEXTILES N.C.A."
                                ]
                            },
                            "FABRICATION D'ETOFFES A MAILLE":{
                                "FABRICATION D'ETOFFES A MAILLE":[
                                    "FABRICATION D'ETOFFES A MAILLE"
                                ]
                            },
                            "FABRICATION D'ARTICLES A MAILLE":{
                                "FABRICATION D'ARTICLES CHAUSSANTS A MAILLE":[
                                    "FABRICATION D'ARTICLES CHAUSSANTS A MAILLE"
                                ],
                                "FABRICATION DE PULL-OVERS ET ARTICLES SIMILAIRES A MAILLE":[
                                    "FABRICATION DE PULL-OVERS ET ARTICLES SIMILAIRES A MAILLE"
                                ]
                            }
                        },
                        "INDUSTRIE DE L'HABILLEMENT ET DES FOURRURES":{
                            "FABRICATION DE VETEMENTS EN CUIR":{
                                "FABRICATION DE VETEMENTS EN CUIR":[
                                    "FABRICATION DE VETEMENTS EN CUIR"
                                ]
                            },
                            "FABRICATION DE VETEMENTS EN TEXTILE":{
                                "FABRICATION DE VETEMENTS DE TRAVAIL":[
                                    "FABRICATION DE VETEMENTS DE TRAVAIL"
                                ],
                                "FABRICATION D'AUTRES VETEMENTS DE DESSUS":[
                                    "FABRICATION DE VETEMENTS SUR MESURE",
                                    "FABRICATION INDUSTRIELLE DE VETEMENTS DE DESSUS",
                                    "FABRICATION ARTISANALE DE VETEMENTS TRADITIONNELS"
                                ],
                                "FABRICATION DE VETEMENTS DE DESSOUS":[
                                    "FABRICATION DE VETEMENTS DE DESSOUS"
                                ],
                                "FABRICATION D'AUTRES VETEMENTS ET ACCESSOIRES":[
                                    "FABRICATION D'AUTRES VETEMENTS ET ACCESSOIRES"
                                ]
                            },
                            "INDUSTRIE DES FOURRURES":{
                                "INDUSTRIE DES FOURRURES":[
                                    "INDUSTRIE DES FOURRURES"
                                ]
                            }
                        }
                    },
                    "INDUSTRIE DU CUIR ET DE LA CHAUSSURE":{
                        "INDUSTRIE DU CUIR ET DE LA CHAUSSURE":{
                            "APPRET ET TANNAGE DES CUIRS":{
                                "APPRET ET TANNAGE DES CUIRS":[
                                    "APPRET ET TANNAGE DES CUIRS"
                                ]
                            },
                            "FABRICATION D'ARTICLES DE VOYAGE ET DE MAROQUINERIE":{
                                "FABRICATION D'ARTICLES DE VOYAGE ET DE MAROQUINERIE":[
                                    "FABRICATION D'ARTICLES DE VOYAGE ET DE MAROQUINERIE"
                                ]
                            },
                            "FABRICATION DE CHAUSSURES":{
                                "FABRICATION DE CHAUSSURES":[
                                    "FABRICATION DE CHAUSSURES",
                                    "FABRICATION ARTISANALE DE CHAUSSURES TRADITIONNELLES"
                                ]
                            }
                        }
                    },
                    "TRAVAIL DU BOIS ET FABRICATION D'ARTICLES EN BOIS":{
                        "TRAVAIL DU BOIS ET FABRICATION D'ARTICLES EN BOIS":{
                            "SCIAGE, RABOTAGE, IMPREGNATION DU BOIS":{
                                "SCIAGE, RABOTAGE, IMPREGNATION DU BOIS":[
                                    "SCIAGE, RABOTAGE, IMPREGNATION DU BOIS"
                                ]
                            },
                            "FABRICATION DE PANNEAUX DE BOIS":{
                                "FABRICATION DE PANNEAUX DE BOIS":[
                                    "FABRICATION DE PANNEAUX DE BOIS"
                                ]
                            },
                            "FABRICATION DE CHARPENTES ET DE MENUISERIES":{
                                "FABRICATION DE CHARPENTES ET DE MENUISERIES":[
                                    "FABRICATION DE CHARPENTES ET DE MENUISERIES"
                                ]
                            },
                            "FABRICATION D'EMBALLAGES EN BOIS":{
                                "FABRICATION D'EMBALLAGES EN BOIS":[
                                    "FABRICATION D'EMBALLAGES EN BOIS"
                                ]
                            },  
                            "FABRICATION D'OBJETS DIVERS EN BOIS, LIEGE OU VANNERIE":{
                                "FABRICATION D'OBJETS DIVERS EN BOIS":[
                                    "FABRICATION D'OBJETS DIVERS EN BOIS"
                                ],
                                "FABRICATION D'OBJETS EN LIEGE, VANNERIE OU SPARTERIE":[
                                    "FABRICATION D'OBJETS EN LIEGE, VANNERIE OU SPARTERIE"
                                ]
                            }
                        }
                    },
                    "INDUSTRIE DU PAPIER ET DU CARTON; EDITION ET IMPRIMERIE":{
                        "INDUSTRIE DU PAPIER ET DU CARTON":{
                            "FABRICATION DE PATE A PAPIER, DE PAPIER ET DE CARTON":{
                                "FABRICATION DE PATE A PAPIER":[
                                    "FABRICATION DE PATE A PAPIER"
                                ],
                                "FABRICATION DE PAPIER ET DE CARTON":[
                                    "FABRICATION DE PAPIER ET DE CARTON"
                                ]
                            },
                            "FABRICATION D'ARTICLES EN PAPIER OU EN CARTON":{
                                "FABRICATION DE CARTON ONDULE ET D'EMBALLAGES EN PAPIER OU EN CARTON":[
                                    "FABRICATION DE CARTON ONDULE ET D'EMBALLAGES EN PAPIER OU EN CARTON"
                                ],
                                "FABRICATION D'ARTICLES EN PAPIER A USAGE SANITAIRE OU DOMESTIQUE":[
                                    "FABRICATION D'ARTICLES EN PAPIER A USAGE SANITAIRE OU DOMESTIQUE"
                                ],
                                "FABRICATION D'ARTICLES DE PAPETERIE":[
                                    "FABRICATION D'ARTICLES DE PAPETERIE"
                                ],
                                "FABRICATION DE PAPIERS PEINTS":[
                                    "FABRICATION DE PAPIERS PEINTS"
                                ],
                                "FABRICATION D'AUTRES ARTICLES EN PAPIER OU EN CARTON":[
                                    "FABRICATION D'AUTRES ARTICLES EN PAPIER OU EN CARTON"
                                ]
                            }
                        },
                        "EDITION, IMPRIMERIE, REPRODUCTION":{
                            "EDITION":{
                                "EDITION DE LIVRES":[
                                    "EDITION DE LIVRES"
                                ],
                                "EDITION DE JOURNAUX":[
                                    "EDITION DE JOURNAUX"
                                ],
                                "EDITION DE REVUES ET PERIODIQUES":[
                                    "EDITION DE REVUES ET PERIODIQUES"
                                ],
                                "EDITION D'ENREGISTREMENTS SONORES":[
                                    "EDITION D'ENREGISTREMENTS SONORES"
                                ],
                                "AUTRES ACTIVITES D'EDITION":[
                                    "AUTRES ACTIVITES D'EDITION"
                                ]
                            },
                            "IMPRIMERIE":{
                                "IMPRIMERIE DE JOURNAUX":[
                                    "IMPRIMERIE DE JOURNAUX"
                                ],
                                "AUTRE IMPRIMERIE (LABEUR)":[
                                    "AUTRE IMPRIMERIE (LABEUR)"
                                ],
                                "RELIURE ET FINITION":[
                                    "RELIURE ET FINITION"
                                ],
                                "COMPOSITION ET PHOTOGRAVURE":[
                                    "COMPOSITION ET PHOTOGRAVURE"
                                ],
                                "AUTRES ACTIVITES GRAPHIQUES":[
                                    "AUTRES ACTIVITES GRAPHIQUES"
                                ]

                            },
                            "REPRODUCTION D'ENREGISTREMENTS":{
                                "REPRODUCTION D'ENREGISTREMENTS SONORES":[
                                    "REPRODUCTION D'ENREGISTREMENTS SONORES"
                                ],
                                "REPRODUCTION D'ENREGISTREMENTS VIDEO":[
                                    "REPRODUCTION D'ENREGISTREMENTS VIDEO"
                                ],
                                "REPRODUCTION D'ENREGISTREMENTS INFORMATIQUES":[
                                    "REPRODUCTION D'ENREGISTREMENTS INFORMATIQUES"
                                ]
                            }
                        }
                    },
                    "COKEFACTION, RAFFINAGE, INDUSTRIES NUCLEAIRES":{
                        "COKEFACTION, RAFFINAGE, INDUSTRIES NUCLEAIRES": {
                            "COKEFACTION":{
                                "COKEFACTION":[
                                    "COKEFACTION"
                                ]
                            },
                            "RAFFINAGE DE PETROLE":{
                                "RAFFINAGE DE PETROLE":[
                                    "RAFFINAGE DE PETROLE"
                                ]
                            },
                            "ELABORATION ET TRANSFORMATION DE MATIERES NUCLEAIRES":{
                                "ELABORATION ET TRANSFORMATION DE MATIERES NUCLEAIRES":[
                                    "ELABORATION ET TRANSFORMATION DE MATIERES NUCLEAIRES"
                                ]
                            }   
                        }
                    },
                    "INDUSTRIE CHIMIQUE":{
                        "INDUSTRIE CHIMIQUE":{
                            "INDUSTRIE CHIMIQUE DE BASE":{
                                "FABRICATION DE GAZ INDUSTRIELS":[
                                    "FABRICATION DE GAZ INDUSTRIELS"
                                ],
                                "FABRICATION DE COLORANTS ET DE PIGMENTS":[
                                    "FABRICATION DE COLORANTS ET DE PIGMENTS"
                                ],
                                "FABRICATION D'AUTRES PRODUITS CHIMIQUES INORGANIQUES DE BASE":[
                                    "FABRICATION D'AUTRES PRODUITS CHIMIQUES INORGANIQUES DE BASE"
                                ],
                                "FABRICATION D'AUTRES PRODUITS CHIMIQUES ORGANIQUES DE BASE":[
                                    "FABRICATION D'AUTRES PRODUITS CHIMIQUES ORGANIQUES DE BASE"
                                ],
                                "FABRICATION DE PRODUITS AZOTES ET D'ENGRAIS":[
                                    "FABRICATION DE PRODUITS AZOTES ET D'ENGRAIS"
                                ],
                                "FABRICATION DE MATIERES PLASTIQUES DE BASE":[
                                    "FABRICATION DE MATIERES PLASTIQUES DE BASE"
                                ],
                                "FABRICATION DE CAOUTCHOUC SYNTHETIQUE":[
                                    "FABRICATION DE CAOUTCHOUC SYNTHETIQUE"
                                ]

                            },
                            "FABRICATION DE PRODUITS AGROCHIMIQUES":{
                                "FABRICATION DE PRODUITS AGROCHIMIQUES":[
                                    "FABRICATION DE PRODUITS AGROCHIMIQUES"
                                ]
                            },
                            "FABRICATION DE PEINTURES ET VERNIS":{
                                "FABRICATION DE PEINTURES ET VERNIS":[
                                    "FABRICATION DE PEINTURES ET VERNIS"
                                ]
                            },
                            "INDUSTRIE PHARMACEUTIQUE":{
                                "FABRICATION DE PRODUITS PHARMACEUTIQUES DE BASE":[
                                    "FABRICATION DE PRODUITS PHARMACEUTIQUES DE BASE"
                                ],
                                "FABRICATION DE PREPARATIONS PHARMACEUTIQUES":[
                                    "FABRICATION DE PREPARATIONS PHARMACEUTIQUES"
                                ]
                            },
                            "FABRICATION DE SAVONS, DE PARFUMS ET DE PRODUITS D'ENTRETIEN":{
                                "FABRICATION DE SAVONS, DETERGENTS ET PRODUITS D'ENTRETIEN":[
                                    "FABRICATION DE SAVONS, DETERGENTS ET PRODUITS D'ENTRETIEN"
                                ],
                                "FABRICATION DE PARFUMS ET DE PRODUITS POUR LA TOILETTE":[
                                    "FABRICATION DE PARFUMS ET DE PRODUITS POUR LA TOILETTE"
                                ]
                            },
                            "FABRICATION D'AUTRES PRODUITS CHIMIQUES":{
                                "FABRICATION DE PRODUITS EXPLOSIFS":[
                                    "FABRICATION DE PRODUITS EXPLOSIFS"
                                ],
                                "FABRICATION DE COLLES ET GELATINES":[
                                    "FABRICATION DE COLLES ET GELATINES"
                                ],
                                "FABRICATION D'HUILES ESSENTIELLES":[
                                    "FABRICATION D'HUILES ESSENTIELLES"
                                ],
                                "FABRICATION DE PRODUITS CHIMIQUES POUR LA PHOTOGRAPHIE":[
                                    "FABRICATION DE PRODUITS CHIMIQUES POUR LA PHOTOGRAPHIE"
                                ],
                                "FABRICATION DE SUPPORTS DE DONNEES":[
                                    "FABRICATION DE SUPPORTS DE DONNEES"
                                ],
                                "FABRICATION DE PRODUITS CHIMIQUES A USAGE INDUSTRIEL":[
                                    "FABRICATION DE PRODUITS CHIMIQUES A USAGE INDUSTRIEL"
                                ]
                            },
                            "FABRICATION DE FIBRES ARTIFICIELLES OU SYNTHETIQUES":{
                                "FABRICATION DE FIBRES ARTIFICIELLES OU SYNTHETIQUES":[
                                    "FABRICATION DE FIBRES ARTIFICIELLES OU SYNTHETIQUES"
                                ]
                            }
                        }
                    },
                    "INDUSTRIE DU CAOUTCHOUC ET DES PLASTIQUES":{
                        "INDUSTRIE DU CAOUTCHOUC ET DES PLASTIQUES":{
                            "INDUSTRIE DU CAOUTCHOUC":{
                                "FABRICATION DE PNEUMATIQUES":[
                                    "FABRICATION DE PNEUMATIQUES"
                                ],
                                "RECHAPAGE DE PNEUMATIQUES":[
                                    "RECHAPAGE DE PNEUMATIQUES"
                                ],
                                "FABRICATION D'AUTRES ARTICLES EN CAOUTCHOUC":[
                                    "FABRICATION D'AUTRES ARTICLES EN CAOUTCHOUC"
                                ]
                            },
                            "TRANSFORMATION DES MATIERES PLASTIQUES":{
                                "FABRICATION DE PLAQUES, FEUILLES, TUBES ET PROFILES EN MATIERES PLASTIQUES":[
                                    "FABRICATION DE PLAQUES, FEUILLES, TUBES ET PROFILES EN MATIERES PLASTIQUES"
                                ],
                                "FABRICATION D'EMBALLAGES EN MATIERES PLASTIQUES":[
                                    "FABRICATION D'EMBALLAGES EN MATIERES PLASTIQUES"
                                ],
                                "FABRICATION D'ELEMENTS EN MATIERES PLASTIQUES POUR LA CONSTRUCTION":[
                                    "FABRICATION D'ELEMENTS EN MATIERES PLASTIQUES POUR LA CONSTRUCTION"
                                ],
                                "FABRICATION D'AUTRES ARTICLES EN MATIERES PLASTIQUES":[
                                    "FABRICATION D'AUTRES ARTICLES EN MATIERES PLASTIQUES"
                                ]
                            }
                        }
                    },
                    "FABRICATION D'AUTRES PRODUITS MINERAUX NON METALLIQUES":{
                        "FABRICATION D'AUTRES PRODUITS MINERAUX NON METALLIQUES":{
                            "FABRICATION DE VERRE ET D'ARTICLES EN VERRE":{
                                "FABRICATION DE VERRE PLAT":[
                                    "FABRICATION DE VERRE PLAT"
                                ],
                                "FA?ONNAGE ET TRANSFORMATION DU VERRE PLAT":[
                                    "FA?ONNAGE ET TRANSFORMATION DU VERRE PLAT"
                                ],
                                "FABRICATION DE VERRE CREUX":[
                                    "FABRICATION DE VERRE CREUX"
                                ],
                                "FABRICATION DE FIBRES DE VERRE":[
                                    "FABRICATION DE FIBRES DE VERRE"
                                ],
                                "FABRICATION ET FA?ONNAGE D'AUTRES ARTICLES EN VERRE":[
                                    "FABRICATION ET FA?ONNAGE D'AUTRES ARTICLES EN VERRE"
                                ]
                            },
                            "FABRICATION DE PRODUITS CERAMIQUES, AUTRES QUE POUR LA CONSTRUCTION":{
                                "FABRICATION D'ARTICLES CERAMIQUES A USAGE DOMESTIQUE OU ORNEMENTAL":[
                                    "FABRICATION D'ARTICLES CERAMIQUES A USAGE DOMESTIQUE OU ORNEMENTAL"
                                ],
                                "FABRICATION D'APPAREILS SANITAIRES EN CERAMIQUE":[
                                    "FABRICATION D'APPAREILS SANITAIRES EN CERAMIQUE"
                                ],
                                "FABRICATION D'ISOLATEURS ET PIECES ISOLANTES EN CERAMIQUE":[
                                    "FABRICATION D'ISOLATEURS ET PIECES ISOLANTES EN CERAMIQUE"
                                ],
                                "FABRICATION D'AUTRES PRODUITS CERAMIQUES A USAGE TECHNIQUE":[
                                    "FABRICATION D'AUTRES PRODUITS CERAMIQUES A USAGE TECHNIQUE"
                                ],
                                "FABRICATION D'AUTRES PRODUITS CERAMIQUES":[
                                    "FABRICATION D'AUTRES PRODUITS CERAMIQUES"
                                ],
                                "FABRICATION DE PRODUITS CERAMIQUES REFRACTAIRES":[
                                    "FABRICATION DE PRODUITS CERAMIQUES REFRACTAIRES"
                                ]
                            },
                            "FABRICATION DE CARREAUX EN CERAMIQUE":{
                                "FABRICATION DE CARREAUX EN CERAMIQUE":[
                                    "FABRICATION DE CARREAUX EN CERAMIQUE"
                                ]
                            },
                            "FABRICATION DE TUILES ET BRIQUES EN TERRE CUITE":{
                                "FABRICATION DE TUILES ET BRIQUES EN TERRE CUITE":[
                                    "FABRICATION DE TUILES ET BRIQUES EN TERRE CUITE"
                                ]
                            },
                            "FABRICATION DE CIMENT, CHAUX ET PLATRE":{
                                "FABRICATION DE CIMENT":[
                                    "FABRICATION DE CIMENT"
                                ],
                                "FABRICATION DE CHAUX":[
                                    "FABRICATION DE CHAUX"
                                ],
                                "FABRICATION DE PLATRE":[
                                    "FABRICATION DE PLATRE"
                                ]
                            },
                            "FABRICATION D'OUVRAGES EN BETON OU EN PLATRE":{
                                "FABRICATION D'ELEMENTS EN BETON POUR LA CONSTRUCTION":[
                                    "FABRICATION DE CARREAUX EN CIMENT",
                                    "FABRICATION D'ELEMENTS EN CIMENT OU EN BETON POUR LA CONSTRUCTION (SAUF CARREAUX)"
                                ],
                                "FABRICATION D'ELEMENTS EN PLATRE POUR LA CONSTRUCTION":[
                                    "FABRICATION D'ELEMENTS EN PLATRE POUR LA CONSTRUCTION"
                                ],
                                "FABRICATION DE BETON PRET A L'EMPLOI":[
                                    "FABRICATION DE BETON PRET A L'EMPLOI"
                                ],
                                "FABRICATION DE MORTIERS ET BETONS SECS":[
                                    "FABRICATION DE MORTIERS ET BETONS SECS"
                                ],
                                "FABRICATION D'OUVRAGES EN FIBRE-CIMENT":[
                                    "FABRICATION D'OUVRAGES EN FIBRE-CIMENT"
                                ],
                                "FABRICATION D'AUTRES OUVRAGES EN BETON OU EN PLATRE":[
                                    "FABRICATION D'AUTRES OUVRAGES EN BETON OU EN PLATRE"
                                ]
                            },
                            "TRAVAIL DE LA PIERRE":{
                                "TRAVAIL DE LA PIERRE":[
                                    "TRAVAIL DE LA PIERRE"
                                ]
                            },
                            "FABRICATION DE PRODUITS MINERAUX DIVERS":{
                                "FABRICATION DE PRODUITS ABRASIFS":[
                                    "FABRICATION DE PRODUITS ABRASIFS"
                                ],
                                "FABRICATION DE PRODUITS MINERAUX NON METALLIQUES N.C.A.":[
                                    "FABRICATION DE PRODUITS MINERAUX NON METALLIQUES N.C.A."
                                ]
                            }
                        }
                    },
                    "METALLURGIE ET TRAVAIL DES METAUX":{
                        "METALLURGIE":{
                            "SIDERURGIE ET PRODUCTION DE FERRO-ALLIAGES":{
                                "SIDERURGIE ET PRODUCTION DE FERRO-ALLIAGES":[
                                    "SIDERURGIE ET PRODUCTION DE FERRO-ALLIAGES"
                                ]
                            },
                            "FABRICATION DE TUBES":{
                                "FABRICATION DE TUBES EN FONTE":[
                                    "FABRICATION DE TUBES EN FONTE"
                                ],
                                "FABRICATION DE TUBES EN ACIER":[
                                    "FABRICATION DE TUBES EN ACIER"
                                ]
                            },
                            "PREMIERE TRANSFORMATION DE L'ACIER":{
                                "ETIRAGE A FROID":[
                                    "ETIRAGE A FROID"
                                ],
                                "LAMINAGE A FROID DE FEUILLARDS":[
                                    "LAMINAGE A FROID DE FEUILLARDS"
                                ],
                                "PROFILAGE A FROID PAR FORMAGE OU PLIAGE":[
                                    "PROFILAGE A FROID PAR FORMAGE OU PLIAGE"
                                ],
                                "TREFILAGE A FROID":[
                                    "TREFILAGE A FROID"
                                ]
                            },
                            "PRODUCTION DE METAUX NON FERREUX":{
                                "PRODUCTION DE METAUX PRECIEUX":[
                                    "PRODUCTION DE METAUX PRECIEUX"
                                ],
                                "METALLURGIE DE L'ALUMINIUM":[
                                    "METALLURGIE DE L'ALUMINIUM"
                                ],
                                "METALLURGIE DU PLOMB, DU ZINC OU DE L'ETAIN":[
                                    "METALLURGIE DU PLOMB, DU ZINC OU DE L'ETAIN"
                                ],
                                "METALLURGIE DU CUIVRE":[
                                    "METALLURGIE DU CUIVRE"
                                ],
                                "METALLURGIE DES AUTRES METAUX NON FERREUX":[
                                    "METALLURGIE DES AUTRES METAUX NON FERREUX"
                                ]
                            },
                            "FONDERIE":{
                                "FONDERIE DE FONTE":[
                                    "FONDERIE DE FONTE"
                                ],
                                "FONDERIE D'ACIER":[
                                    "FONDERIE D'ACIER"
                                ],
                                "FONDERIE DE METAUX LEGERS":[
                                    "FONDERIE DE METAUX LEGERS"
                                ],
                                "FONDERIE D'AUTRES METAUX NON FERREUX":[
                                    "FONDERIE D'AUTRES METAUX NON FERREUX"
                                ]
                            }
                        },
                        "TRAVAIL DES METAUX":{
                            "FABRICATION D'ELEMENTS EN METAL POUR LA CONSTRUCTION":{
                                "FABRICATION DE CONSTRUCTIONS METALLIQUES":[
                                    "FABRICATION DE CONSTRUCTIONS METALLIQUES"
                                ],
                                "FABRICATION DE MENUISERIES ET FERMETURES METALLIQUES":[
                                    "FABRICATION DE MENUISERIES ET DE FERMETURES METALLIQUES"
                                ]
                            },
                            "FABRICATION DE RESERVOIRS METALLIQUES ET DE CHAUDIERES POUR LE CHAUFFAGE CENTRAL":{
                                "FABRICATION DE RESERVOIRS, CITERNES ET CONTENEURS METALLIQUES":[
                                        "FABRICATION DE RESERVOIRS ET CITERNES METALLIQUES",
                                        "FABRICATION DE BOUTEILLES POUR GAZ COMPRIMES"
                                ],
                                "FABRICATION DE RADIATEURS ET DE CHAUDIERES POUR LE CHAUFFAGE CENTRAL":[
                                    "FABRICATION DE RADIATEURS ET DE CHAUDIERES POUR LE CHAUFFAGE CENTRAL"
                                ]
                            },
                            "CHAUDRONNERIE":{
                                "CHAUDRONNERIE":[
                                    "CHAUDRONNERIE"
                                ]
                            },
                            "FORGE, EMBOUTISSAGE, ESTAMPAGE; METALLURGIE DES POUDRES":{
                                "FORGE, EMBOUTISSAGE, ESTAMPAGE; METALLURGIE DES POUDRES":[
                                    "FORGE, EMBOUTISSAGE, ESTAMPAGE ; METALLURGIE DES POUDRES"
                                ]
                            },
                            "TRAITEMENT DES METAUX ; MECANIQUE GENERALE":{
                                "TRAITEMENT ET REVETEMENT DES METAUX":[
                                    "TRAITEMENT ET REVETEMENT DES METAUX"
                                ],
                                "OPERATIONS DE MECANIQUE GENERALE":[
                                    "OPERATIONS DE MECANIQUE GENERALE"
                                ]
                            },  
                            "FABRICATION DE COUTELLERIE, D'OUTILLAGE ET DE QUINCAILLERIE":{
                                "FABRICATION DE COUTELLERIE":[
                                    "FABRICATION DE COUTELLERIE"
                                ],
                                "FABRICATION D'OUTILLAGE":[
                                    "FABRICATION D'OUTILLAGE A MAIN",
                                    "FABRICATION D'OUTILLAGE MECANIQUE"
                                ],
                                "FABRICATION DE SERRURES ET DE FERRURES":[
                                    "FABRICATION DE SERRURES ET DE FERRURES"
                                ]
                            },
                            "FABRICATION D'AUTRES OUVRAGES EN METAUX":{
                                "FABRICATION DE FUTS ET EMBALLAGES METALLIQUES SIMILAIRES":[
                                    "FABRICATION DE FUTS ET EMBALLAGES METALLIQUES SIMILAIRES"
                                ],
                                "FABRICATION D'EMBALLAGES METALLIQUES LEGERS":[
                                    "FABRICATION D'EMBALLAGES METALLIQUES LEGERS"
                                ],
                                "FABRICATION D'ARTICLES EN FILS METALLIQUES":[
                                    "FABRICATION D'ARTICLES EN FILS METALLIQUES"
                                ],
                                "VISSERIE ET BOULONNERIE; FABRICATION DE CHAINES ET DE RESSORTS":[
                                    "VISSERIE ET BOULONNERIE ; FABRICATION DE CHAINES ET DE RESSORTS"
                                ],
                                "FABRICATION D'OUVRAGES DIVERS EN METAUX":[
                                    "FABRICATION D'OUVRAGES DIVERS EN METAUX",
                                    "FABRICATION ARTISANALE D'OUVRAGES TRADITIONNELS EN METAUX"
                                ]
                            }
                        }
                    },
                    "FABRICATION DE MACHINES ET EQUIPEMENTS":{
                        "FABRICATION DE MACHINES ET EQUIPEMENTS":{
                            "FABRICATION D'EQUIPEMENTS MECANIQUES":{
                                "FABRICATION DE MOTEURS ET TURBINES":[
                                    "FABRICATION DE MOTEURS ET TURBINES"
                                ],
                                "FABRICATION DE POMPES, COMPRESSEURS ET SYSTEMES HYDRAULIQUES":[
                                    "FABRICATION DE POMPES, COMPRESSEURS ET SYSTEMES HYDRAULIQUES"
                                ],
                                "FABRICATION D'ARTICLES DE ROBINETTERIE":[
                                    "FABRICATION D'ARTICLES DE ROBINETTERIE"
                                ],
                                "FABRICATION D'ENGRENAGES ET D'ORGANES MECANIQUES DE TRANSMISSION":[
                                    "FABRICATION D'ENGRENAGES ET D'ORGANES MECANIQUES DE TRANSMISSION"
                                ]
                            },
                            "FABRICATION DE MACHINES D'USAGE GENERAL":{
                                "FABRICATION DE FOURS ET BRULEURS":[
                                    "FABRICATION DE FOURS ET BRULEURS"
                                ],
                                "FABRICATION DE MATERIEL DE LEVAGE ET DE MANUTENTION":[
                                    "FABRICATION DE MATERIEL DE LEVAGE ET DE MANUTENTION"
                                ],
                                "FABRICATION D'EQUIPEMENTS AERAULIQUES ET FRIGORIFIQUES INDUSTRIELS":[
                                    "FABRICATION D'EQUIPEMENTS AERAULIQUES ET FRIGORIFIQUES INDUSTRIELS"
                                ],
                                "FABRICATION D'AUTRES MACHINES D'USAGE GENERAL":[
                                    "FABRICATION D'AUTRES MACHINES D'USAGE GENERAL"
                                ]
                            },
                            "FABRICATION DE MACHINES AGRICOLES":{
                                "FABRICATION DE TRACTEURS AGRICOLES":[
                                    "FABRICATION DE TRACTEURS AGRICOLES"
                                ],
                                "FABRICATION D'AUTRES MACHINES AGRICOLES":[
                                    "FABRICATION DE MATERIEL AGRICOLE",
                                    "REPARATION DE MATERIEL AGRICOLE"
                                ]
                            },
                            "FABRICATION DE MACHINES-OUTILS":{
                                "FABRICATION DE MACHINES-OUTILS":[
                                    "FABRICATION DE MACHINES-OUTILS A METAL OU A BOIS",
                                    "FABRICATION DE MACHINES-OUTILS PORTATIVES A MOTEUR INCORPORE",
                                    "FABRICATION DE MATERIEL DE SOUDAGE"
                                ]
                            },
                            "FABRICATION D'AUTRES MACHINES D'USAGE SPECIFIQUE":{
                                "FABRICATION DE MACHINES POUR LA METALLURGIE":[
                                    "FABRICATION DE MACHINES POUR LA METALLURGIE"
                                ],
                                "FABRICATION DE MACHINES POUR L'EXTRACTION OU LA CONSTRUCTION":[
                                    "FABRICATION DE MACHINES POUR L'EXTRACTION OU LA CONSTRUCTION"
                                ],
                                "FABRICATION DE MACHINES POUR L'INDUSTRIE AGRO-ALIMENTAIRE":[
                                    "FABRICATION DE MACHINES POUR L'INDUSTRIE AGRO-ALIMENTAIRE"
                                ],
                                "FABRICATION DE MACHINES POUR LES INDUSTRIES TEXTILES":[
                                    "FABRICATION DE MACHINES POUR LES INDUSTRIES TEXTILES"
                                ],
                                "FABRICATION DE MACHINES POUR LES INDUSTRIES DU PAPIER ET DU CARTON":[
                                    "FABRICATION DE MACHINES POUR LES INDUSTRIES DU PAPIER ET DU CARTON"
                                ],
                                "FABRICATION DE MACHINES DIVERSES D'USAGE SPECIFIQUE":[
                                    "FABRICATION DE MACHINES DIVERSES D'USAGE SPECIFIQUE"
                                ]
                            },
                            "FABRICATION D'ARMES ET DE MUNITIONS":{
                                "FABRICATION D'ARMES ET DE MUNITIONS":[
                                    "FABRICATION D'ARMES ET DE MUNITIONS"
                                ]
                            },
                            "FABRICATION D'APPAREILS DOMESTIQUES N.C.A":{
                                "FABRICATION D'APPAREILS ELECTROMENAGERS":[
                                    "FABRICATION D'APPAREILS ELECTROMENAGERS"
                                ],
                                "FABRICATION D'APPAREILS MENAGERS NON ELECTRIQUES":[
                                    "FABRICATION D'APPAREILS MENAGERS NON ELECTRIQUES"
                                ]
                            }
                        }
                    },
                    "FABRICATION D'EQUIPEMENTS ELECTRIQUES ET ELECTRONIQUES":{
                        "FABRICATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":{
                            "FABRICATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":{
                                "FABRICATION DE MACHINES DE BUREAU":[
                                    "FABRICATION DE MACHINES DE BUREAU"
                                ],
                                "FABRICATION D'ORDINATEURS ET D'AUTRES EQUIPEMENTS INFORMATIQUES":[
                                    "FABRICATION D'ORDINATEURS ET D'AUTRES EQUIPEMENTS INFORMATIQUES"
                                ],
                            }
                        },
                        "FABRICATION DE MACHINES ET APPAREILS ELECTRIQUES":{
                            "FABRICATION DE MOTEURS, GENERATRICES ET TRANSFORMATEURS ELECTRIQUES":{
                                "FABRICATION DE MOTEURS, GENERATRICES ET TRANSFORMATEURS ELECTRIQUES":[
                                    "FABRICATION DE MOTEURS, GENERATRICES ET TRANSFORMATEURS ELECTRIQUES",
                                    "REPARATION DE MATERIELS ELECTRIQUES"
                                ]
                            },
                            "FABRICATION DE MATERIEL DE DISTRIBUTION ET DE COMMANDE ELECTRIQUE":{
                                "FABRICATION DE MATERIEL DE DISTRIBUTION ET DE COMMANDE ELECTRIQUE":[
                                    "FABRICATION DE MATERIEL DE DISTRIBUTION ET DE COMMANDE ELECTRIQUE"
                                ]
                            },
                            "FABRICATION DE FILS ET CABLES ISOLES":{
                                "FABRICATION DE FILS ET CABLES ISOLES":[
                                    "FABRICATION DE FILS ET CABLES ISOLES"
                                ]
                            },
                            "FABRICATION D'ACCUMULATEURS ET DE PILES ELECTRIQUES":{
                                "FABRICATION D'ACCUMULATEURS ET DE PILES ELECTRIQUES":[
                                    "FABRICATION D'ACCUMULATEURS ET DE PILES ELECTRIQUES"
                                ]
                            },
                            "FABRICATION DE LAMPES ET D'APPAREILS D'ECLAIRAGE":{
                                "FABRICATION DE LAMPES ET D'APPAREILS D'ECLAIRAGE":[
                                    "FABRICATION DE LAMPES",
                                    "FABRICATION D'APPAREILS D'ECLAIRAGE"
                                ]
                            },
                            "FABRICATION D'AUTRES MATERIELS ELECTRIQUES":{
                                "FABRICATION DE MATERIELS ELECTRIQUES POUR MOTEURS ET VEHICULES":[
                                    "FABRICATION DE MATERIELS ELECTRIQUES POUR MOTEURS ET VEHICULES"
                                ],
                                "FABRICATION DE MATERIELS ELECTRIQUES, SAUF POUR MOTEURS ET VEHICULES":[
                                    "FABRICATION DE MATERIELS ELECTRIQUES, SAUF POUR MOTEURS ET VEHICULES"
                                ]
                            }
                        },
                        "FABRICATION D'EQUIPEMENTS DE RADIO, TELEVISION ET COMMUNICATION":{
                            "FABRICATION DE COMPOSANTS ELECTRONIQUES":{
                                "FABRICATION DE COMPOSANTS ELECTRONIQUES":[
                                    "FABRICATION DE COMPOSANTS ELECTRONIQUES"
                                ]
                            },
                            "FABRICATION D'APPAREILS D'EMISSION ET DE TRANSMISSION":{
                                "FABRICATION D'APPAREILS D'EMISSION ET DE TRANSMISSION":[
                                    "FABRICATION D'EQUIPEMENTS D'EMISSION ET DE TRANSMISSION HERTZIENNE",
                                    "FABRICATION D'APPAREILS DE TELEPHONIE"
                                ]
                            },
                            "FABRICATION D'APPAREILS DE RECEPTION, ENREGISTREMENT OU REPRODUCTION DU SON ET DE L'IMAGE":{
                                "FABRICATION D'APPAREILS DE RECEPTION, ENREGISTREMENT OU REPRODUCTION DU SON ET DE L'IMAGE":[
                                    "FABRICATION D'APPAREILS DE RECEPTION, ENREGISTREMENT OU REPRODUCTION DU SON ET DE L'IMAGE"
                                ]
                            }
                        },
                        "FABRICATION D'INSTRUMENTS MEDICAUX, DE PRECISION, D'OPTIQUE ET D'HORLOGERIE":{
                            "FABRICATION DE MATERIEL MEDICO-CHIRURGICAL ET D'ORTHOPEDIE":{
                                "FABRICATION DE MATERIEL MEDICO-CHIRURGICAL ET D'ORTHOPEDIE":[
                                    "FABRICATION DE MATERIEL MEDICO-CHIRURGICAL ET D'ORTHOPEDIE"
                                ]
                            },
                            "FABRICATION D'INSTRUMENTS DE MESURE ET DE CONTROLE":{
                                "FABRICATION D'INSTRUMENTS DE MESURE ET DE CONTROLE":[
                                    "FABRICATION D'INSTRUMENTS DE MESURE ET DE CONTROLE"
                                ]
                            },
                            "FABRICATION D'EQUIPEMENTS DE CONTROLE DES PROCESSUS INDUSTRIELS":{
                                "FABRICATION D'EQUIPEMENTS DE CONTROLE DES PROCESSUS INDUSTRIELS":[
                                    "FABRICATION D'EQUIPEMENTS DE CONTROLE DES PROCESSUS INDUSTRIELS"
                                ]
                            },
                            "FABRICATION DE MATERIELS OPTIQUE ET PHOTOGRAPHIQUE":{
                                "FABRICATION DE MATERIELS OPTIQUE ET PHOTOGRAPHIQUE":[
                                    "FABRICATION DE LUNETTES",
                                    "FABRICATION D'INSTRUMENTS D'OPTIQUE ET DE MATERIEL PHOTOGRAPHIQUE"
                                ]
                            },
                            "HORLOGERIE":{
                                "HORLOGERIE":[
                                    "HORLOGERIE"
                                ]
                            }
                        }
                    },
                    "FABRICATION DE MATERIEL DE TRANSPORT":{
                        "INDUSTRIE AUTOMOBILE":{
                            "CONSTRUCTION DE VEHICULES AUTOMOBILES": {
                                "CONSTRUCTION DE VEHICULES AUTOMOBILES":[
                                    "CONSTRUCTION DE VEHICULES AUTOMOBILES"
                                ]
                            },
                            "FABRICATION DE CARROSSERIES ET REMORQUES":{
                                "FABRICATION DE CARROSSERIES ET REMORQUES":[
                                    "FABRICATION DE CARROSSERIES ET REMORQUES"
                                ]
                            },
                            "FABRICATION D'EQUIPEMENTS AUTOMOBILES":{
                                "FABRICATION D'EQUIPEMENTS AUTOMOBILES":[
                                    "FABRICATION D'EQUIPEMENTS AUTOMOBILES"
                                ]
                            }   
                        },
                        "FABRICATION D'AUTRES MATERIELS DE TRANSPORT":{
                            "CONSTRUCTION ET REPARATION NAVALE":{
                                "CONSTRUCTION ET REPARATION DE NAVIRES":[
                                    "CONSTRUCTION DE NAVIRES",
                                    "REPARATION NAVALE"
                                ],
                                "CONSTRUCTION DE BATEAUX DE PLAISANCE":[
                                    "CONSTRUCTION DE BATEAUX DE PLAISANCE"
                                ]
                            },  
                            "CONSTRUCTION DE MATERIEL FERROVIAIRE ROULANT":{
                                "CONSTRUCTION DE MATERIEL FERROVIAIRE ROULANT":[
                                    "CONSTRUCTION DE MATERIEL FERROVIAIRE ROULANT"
                                ]
                            },
                            "CONSTRUCTION AERONAUTIQUE ET SPATIALE":{
                                "CONSTRUCTION AERONAUTIQUE ET SPATIALE":[
                                    "CONSTRUCTION AERONAUTIQUE ET SPATIALE"
                                ]
                            },
                            "FABRICATION DE MOTOCYCLES ET DE BICYCLETTES":{
                                "FABRICATION DE MOTOCYCLES":[
                                    "FABRICATION DE MOTOCYCLES"
                                ],
                                "FABRICATION DE BICYCLETTES":[
                                    "FABRICATION DE BICYCLETTES"
                                ],
                                "FABRICATION DE VEHICULES POUR INVALIDES":[
                                    "FABRICATION DE VEHICULES POUR INVALIDES"
                                ]
                            },
                            "FABRICATION DE MATERIELS DE TRANSPORT N.C.A.":{
                                "FABRICATION DE MATERIELS DE TRANSPORT N.C.A.":[
                                    "FABRICATION DE MATERIELS DE TRANSPORT N.C.A."
                                ]
                            }
                        }
                    },
                    "AUTRES INDUSTRIES MANUFACTURIERES":{
                        "FABRICATION DE MEUBLES; INDUSTRIES DIVERSES":{
                            "FABRICATION DE MEUBLES":{
                                "FABRICATION DE SIEGES":[
                                    "FABRICATION DE SIEGES"
                                ],
                                "FABRICATION D'AUTRES MEUBLES DE BUREAU ET DE MAGASIN":[
                                    "FABRICATION D'AUTRES MEUBLES DE BUREAU ET DE MAGASIN"
                                ],
                                "FABRICATION DE MEUBLES DE CUISINE":[
                                    "FABRICATION DE MEUBLES DE CUISINE"
                                ],
                                "FABRICATION D'AUTRES MEUBLES":[
                                    "FABRICATION DE MEUBLES N.C.A",
                                    "INDUSTRIES CONNEXES DE L'AMEUBLEMENT"
                                ],
                                "FABRICATION DE MATELAS":[
                                    "FABRICATION DE MATELAS"
                                ]
                            },
                            "BIJOUTERIE":{
                                "FABRICATION DE MONNAIES ET MEDAILLES":[
                                    "FABRICATION DE MONNAIES ET MEDAILLES"
                                ],
                                "BIJOUTERIE, JOAILLERIE, ORFEVRERIE":[
                                    "BIJOUTERIE, JOAILLERIE, ORFEVRERIE"
                                ]
                            },
                            "FABRICATION D'INSTRUMENTS DE MUSIQUE":{
                                "FABRICATION D'INSTRUMENTS DE MUSIQUE":[
                                    "FABRICATION D'INSTRUMENTS DE MUSIQUE"
                                ]
                            },
                            "FABRICATION D'ARTICLES DE SPORT":{
                                "FABRICATION D'ARTICLES DE SPORT":[
                                    "FABRICATION D'ARTICLES DE SPORT"
                                ]
                            },
                            "FABRICATION DE JEUX ET JOUETS":{
                                "FABRICATION DE JEUX ET JOUETS":[
                                    "FABRICATION DE JEUX ET JOUETS"
                                ]
                            },
                            "AUTRES INDUSTRIES DIVERSES":{
                                "BIJOUTERIE FANTAISIE":[
                                    "BIJOUTERIE FANTAISIE"
                                ],
                                "INDUSTRIE DE LA BROSSERIE":[
                                    "INDUSTRIE DE LA BROSSERIE"
                                ],
                                "AUTRES ACTIVITES MANUFACTURIERES N.C.A.":[
                                    "AUTRES ACTIVITES MANUFACTURIERES N.C.A."
                                ]
                            }
                        },
                        "RECUPERATION":{
                            "RECUPERATION DE MATIERES METALLIQUES RECYCLABLES":{
                                "RECUPERATION DE MATIERES METALLIQUES RECYCLABLES":[
                                    "RECUPERATION DE MATIERES METALLIQUES RECYCLABLES"
                                ]
                            },
                            "RECUPERATION DE MATIERES NON METALLIQUES RECYCLABLES":{
                                "RECUPERATION DE MATIERES NON METALLIQUES RECYCLABLES":[
                                    "RECUPERATION DE MATIERES NON METALLIQUES RECYCLABLES"
                                ]
                            }
                        }
                    }
                },
                "PRODUCTION ET DISTRIBUTION D'ELECTRICITE, DE GAZ ET D'EAU":{
                    "PRODUCTION ET DISTRIBUTION D'ELECTRICITE, DE GAZ ET D'EAU":{
                        "PRODUCTION ET DISTRIBUTION D'ELECTRICITE, DE GAZ ET DE CHALEUR":{
                            "PRODUCTION ET DISTRIBUTION D'ELECTRICITE":{
                                "PRODUCTION ET DISTRIBUTION D'ELECTRICITE":[
                                    "PRODUCTION ET DISTRIBUTION D'ELECTRICITE"
                                ]
                            },
                            "PRODUCTION ET DISTRIBUTION DE COMBUSTIBLES GAZEUX":{
                                "PRODUCTION ET DISTRIBUTION DE COMBUSTIBLES GAZEUX":[
                                    "PRODUCTION ET DISTRIBUTION DE COMBUSTIBLES GAZEUX"
                                ]
                            },
                            "PRODUCTION ET DISTRIBUTION DE CHALEUR":{
                                "PRODUCTION ET DISTRIBUTION DE CHALEUR":[
                                    "PRODUCTION ET DISTRIBUTION DE CHALEUR"
                                ]
                            }
                        },
                        "CAPTAGE, TRAITEMENT ET DISTRIBUTION D'EAU":{
                            "CAPTAGE, TRAITEMENT ET DISTRIBUTION D'EAU":{
                                "CAPTAGE, TRAITEMENT ET DISTRIBUTION D'EAU":[
                                    "CAPTAGE, TRAITEMENT ET DISTRIBUTION D'EAU"
                                ]
                            }
                        }
                    }
                },
                "CONSTRUCTION":{
                    "CONSTRUCTION":{
                        "CONSTRUCTION":{
                            "PREPARATION DES SITES":{
                                "DEMOLITION ET TERRASSEMENTS":[
                                    "DEMOLITION ET TERRASSEMENTS"
                                ],
                                "FORAGES ET SONDAGES":[
                                    "FORAGES ET SONDAGES"
                                ]
                            },
                            "CONSTRUCTION D'OUVRAGES DE BATIMENT OU DE GENIE CIVIL":{
                                "TRAVAUX DE CONSTRUCTION":[
                                    "CONSTRUCTION DE BATIMENTS ( GROS ŒUVRE )",
                                    "CONSTRUCTION D'OUVRAGES D'ART ET DE TUNNELS",
                                    "CONSTRUCTION DE RESEAUX",
                                    "CONSTRUCTION DE LIGNES ELECTRIQUES ET DE TELECOMMUNICATIONS"
                                ],
                                "REALISATION DE CHARPENTES ET DE COUVERTURES":[
                                    "REALISATION DE CHARPENTES ET DE COUVERTURES"
                                ],
                                "CONSTRUCTION DE CHAUSSEES":[
                                    "CONSTRUCTION DE VOIES FERREES",
                                    "CONSTRUCTION DE CHAUSSEES ROUTIERES ET DE SOLS SPORTIFS"
                                ],
                                "TRAVAUX MARITIMES ET HYDRAULIQUES":[
                                    "TRAVAUX MARITIMES ET HYDRAULIQUES"
                                ],
                                "AUTRES TRAVAUX DE CONSTRUCTION":[
                                    "AUTRES TRAVAUX DE CONSTRUCTION"
                                ]
                            },
                            "TRAVAUX D'INSTALLATION":{
                                "TRAVAUX D'INSTALLATION ELECTRIQUE":[
                                    "TRAVAUX D'INSTALLATION ELECTRIQUE"
                                ],
                                "TRAVAUX D'ISOLATION":[
                                    "TRAVAUX D'ISOLATION"
                                ],
                                "PLOMBERIE":[
                                    "TRAVAUX D'INSTALLATION D'EAU ET DE GAZ",
                                    "TRAVAUX D'INSTALLATION D'EQUIPEMENTS THERMIQUES ET DE CLIMATISATION"
                                ],
                                "AUTRES TRAVAUX D'INSTALLATION":[
                                    "AUTRES TRAVAUX D'INSTALLATION"
                                ]
                            },
                            "TRAVAUX DE FINITION":{
                                "PLATRERIE":[
                                    "PLATRERIE"
                                ],
                                "MENUISERIE":[
                                    "INSTALLATION DE MENUISERIE DE BOIS ET DE MATIERES PLASTIQUES",
                                    "INSTALLATION DE MENUISERIE METALLIQUE; SERRURERIE"
                                ],
                                "REVETEMENT DES SOLS ET DES MURS":[
                                    "REVETEMENT DES SOLS ET DES MURS"
                                ],
                                "PEINTURE ET VITRERIE":[
                                    "MIROITERIE DE BATIMENT; VITRERIE",
                                    "PEINTURE"
                                ],
                                "AUTRES TRAVAUX DE FINITION":[
                                    "AUTRES TRAVAUX DE FINITION"
                                ]
                            },
                            "LOCATION AVEC OPERATEUR DE MATERIEL DE CONSTRUCTION":{
                                "LOCATION AVEC OPERATEUR DE MATERIEL DE CONSTRUCTION":[
                                    "LOCATION AVEC OPERATEUR DE MATERIEL DE CONSTRUCTION"
                                ]
                            }
                        }
                    }
                },
                "COMMERCE; REPARATIONS AUTOMOBILE ET D'ARTICLES DOMESTIQUES":{
                    "COMMERCE; REPARATIONS AUTOMOBILE ET D'ARTICLES DOMESTIQUES":{
                        "COMMERCE ET REPARATION AUTOMOBILE":{
                            "COMMERCE DE VEHICULES AUTOMOBILES":{
                                "COMMERCE DE VEHICULES AUTOMOBILES":[
                                    "COMMERCE DE VEHICULES AUTOMOBILES"
                                ]
                            },
                            "ENTRETIEN ET REPARATION DE VEHICULES AUTOMOBILES":{
                                "ENTRETIEN ET REPARATION DE VEHICULES AUTOMOBILES":[
                                    "ENTRETIEN ET REPARATION DE VEHICULES AUTOMOBILES"
                                ]
                            },
                            "COMMERCE D'EQUIPEMENTS AUTOMOBILES":{
                                "COMMERCE D'EQUIPEMENTS AUTOMOBILES":[
                                    "COMMERCE D'EQUIPEMENTS AUTOMOBILES"
                                ]
                            },
                            "COMMERCE ET REPARATION DE MOTOCYCLES":{
                                "COMMERCE ET REPARATION DE MOTOCYCLES":[
                                    "COMMERCE DE MOTOCYCLES",
                                    "REPARATION DE MOTOCYCLES"
                                ]
                            },
                            "COMMERCE DE DETAIL DE CARBURANTS": {
                                "COMMERCE DE DETAIL DE CARBURANTS":[
                                    "COMMERCE DE DETAIL DE CARBURANTS"
                                ]
                            }
                        },
                        "COMMERCE DE GROS ET INTERMEDIAIRES DU COMMERCE":{
                            "INTERMEDIAIRES DU COMMERCE DE GROS":{
                                "INTERMEDIAIRES DU COMMERCE EN MATIERES PREMIERES AGRICOLES, ANIMAUX VIVANTS, MATIERES PREMIERES TEXT":[
                                    "INTERMEDIAIRES DU COMMERCE EN MATIERES PREMIERES AGRICOLES, ANIMAUX VIVANTS, MATIERES PREMIERES TEXTILES ET DEMI-PRODUITS"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN COMBUSTIBLES, METAUX, MINERAUX ET PRODUITS CHIMIQUES":[
                                    "INTERMEDIAIRES DU COMMERCE EN COMBUSTIBLES, METAUX, MINERAUX ET PRODUITS CHIMIQUES"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN BOIS ET MATERIAUX DE CONSTRUCTION":[
                                    "INTERMEDIAIRES DU COMMERCE EN BOIS ET MATERIAUX DE CONSTRUCTION"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN MACHINES, EQUIPEMENTS INDUSTRIELS, NAVIRES ET AVIONS":[
                                    "INTERMEDIAIRES DU COMMERCE EN MACHINES, EQUIPEMENTS INDUSTRIELS, NAVIRES ET AVIONS"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN MEUBLES, ARTICLES DE MENAGE ET QUINCAILLERIE":[
                                    "INTERMEDIAIRES DU COMMERCE EN MEUBLES, ARTICLES DE MENAGE ET QUINCAILLERIE"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN TEXTILES, HABILLEMENT, CHAUSSURES ET ARTICLES EN CUIR":[
                                    "INTERMEDIAIRES DU COMMERCE EN TEXTILES, HABILLEMENT, CHAUSSURES ET ARTICLES EN CUIR"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN DENREES, BOISSONS ET TABAC":[
                                    "INTERMEDIAIRES DU COMMERCE EN DENREES, BOISSONS ET TABAC"
                                ],
                                "AUTRES INTERMEDIAIRES SPECIALISES DU COMMERCE":[
                                    "AUTRES INTERMEDIAIRES SPECIALISES DU COMMERCE"
                                ],
                                "INTERMEDIAIRES DU COMMERCE EN PRODUITS DIVERS":[
                                    "INTERMEDIAIRES DU COMMERCE EN PRODUITS DIVERS"
                                ]

                            },
                            "COMMERCE DE GROS DE PRODUITS AGRICOLES BRUTS":{
                                "COMMERCE DE GROS DE CEREALES ET ALIMENTS POUR LE BETAIL":[
                                    "COMMERCE DE GROS DE CEREALES ET ALIMENTS POUR LE BETAIL"
                                ],
                                "COMMERCE DE GROS DE FLEURS ET PLANTES":[
                                    "COMMERCE DE GROS DE FLEURS ET PLANTES"
                                ],
                                "COMMERCE DE GROS D'ANIMAUX VIVANTS":[
                                    "COMMERCE DE GROS D'ANIMAUX VIVANTS"
                                ],
                                "COMMERCE DE GROS DE CUIRS ET PEAUX":[
                                    "COMMERCE DE GROS DE CUIRS ET PEAUX"
                                ],
                                "COMMERCE DE GROS DE TABAC NON MANUFACTURE":[
                                     "COMMERCE DE GROS DE TABAC NON MANUFACTURE"
                                ]
                            },
                            "COMMERCE DE GROS DE PRODUITS ALIMENTAIRES":{
                                "COMMERCE DE GROS DE FRUITS ET LEGUMES":[
                                     "COMMERCE DE GROS DE FRUITS ET LEGUMES"
                                ],
                                "COMMERCE DE GROS DE VIANDES (Y COMPRIS VOLAILLES)":[
                                    "COMMERCE DE GROS DE VIANDES (Y COMPRIS VOLAILLES)"
                                ],
                                "COMMERCE DE GROS DE PRODUITS LAITIERS, ŒUFS, HUILES ET GRAISSES COMESTIBLES":[
                                     "COMMERCE DE GROS DE PRODUITS LAITIERS, ŒUFS, HUILES ET GRAISSES COMESTIBLES"
                                ],
                                "COMMERCE DE GROS DE BOISSONS":[
                                    "COMMERCE DE GROS DE BOISSONS"
                                ],
                                "COMMERCE DE GROS DE TABAC":[
                                    "COMMERCE DE GROS DE TABAC"
                                ],
                                "COMMERCE DE GROS  DE SUCRE, CHOCOLAT ET CONFISERIE":[
                                    "COMMERCE DE GROS  DE SUCRE, CHOCOLAT ET CONFISERIE"
                                ],
                                "COMMERCE DE GROS DE CAFE, THE, CACAO ET EPICES":[
                                    "COMMERCE DE GROS DE CAFE, THE, CACAO ET EPICES"
                                ],
                                "AUTRES COMMERCES DE GROS ALIMENTAIRES SPECIALISES":[
                                    "COMMERCE DE GROS DE POISSONS, CRUSTACES ET MOLLUSQUES",
                                    "COMMERCES DE GROS ALIMENTAIRES SPECIALISES DIVERS"
                                ],
                                "COMMERCE DE GROS NON SPECIALISE DE DENREES, BOISSONS ET TABAC":[
                                    "COMMERCE DE GROS NON SPECIALISE DE DENREES, BOISSONS ET TABAC"
                                ]
                            },
                            "COMMERCE DE GROS DE BIENS DE CONSOMMATION NON ALIMENTAIRES":{
                                "COMMERCE DE GROS DE TEXTILES":[
                                     "COMMERCE DE GROS DE TEXTILES"
                                ],
                                "COMMERCE DE GROS D'HABILLEMENT ET DE CHAUSSURES":[
                                    "COMMERCE DE GROS D'HABILLEMENT",
                                    "COMMERCE DE GROS DE LA  CHAUSSURE"
                                ],
                                "COMMERCE DE GROS D'APPAREILS ELECTROMENAGERS ET DE RADIOTELEVISION":[
                                    "COMMERCE DE GROS D'APPAREILS ELECTROMENAGERS ET DE RADIOTELEVISION"
                                ],
                                "COMMERCE DE GROS DE CERAMIQUE, VERRERIE ET PRODUITS D'ENTRETIEN":[
                                    "COMMERCE DE GROS DE CERAMIQUE, VERRERIE ET PRODUITS D'ENTRETIEN"
                                ],
                                "COMMERCE DE GROS DE PARFUMERIE ET DE PRODUITS DE BEAUTE":[
                                    "COMMERCE DE GROS DE PARFUMERIE ET DE PRODUITS DE BEAUTE"
                                ],
                                "COMMERCE DE GROS DE PRODUITS PHARMACEUTIQUES":[
                                    "COMMERCE DE GROS DE PRODUITS PHARMACEUTIQUES"
                                ],
                                "COMMERCE DE GROS DE BIENS DE CONSOMMATION NON ALIMENTAIRES DIVERS":[
                                    "COMMERCE DE GROS DE BIENS DE CONSOMMATION NON ALIMENTAIRES DIVERS"
                                ]
                            },
                            "COMMERCE DE GROS DE PRODUITS INTERMEDIAIRES NON AGRICOLES":{
                                "COMMERCE DE GROS DE COMBUSTIBLES":[
                                    "COMMERCE DE GROS DE COMBUSTIBLES"
                                ],
                                "COMMERCE DE GROS DE MINERAIS ET METAUX":[
                                    "COMMERCE DE GROS DE MINERAIS ET METAUX"
                                ],
                                "COMMERCE DE GROS DE BOIS ET DE MATERIAUX DE CONSTRUCTION":[
                                    "COMMERCE DE GROS DE BOIS ET DE PRODUITS DERIVES",
                                    "COMMERCE DE GROS DE MATERIAUX DE CONSTRUCTION ET D'APPAREILS SANITAIRES"
                                ],
                                "COMMERCE DE GROS DE QUINCAILLERIE ET FOURNITURES POUR PLOMBERIE ET CHAUFFAGE":[
                                    "COMMERCE DE GROS DE QUINCAILLERIE ET FOURNITURES POUR PLOMBERIE ET CHAUFFAGE"
                                ],
                                "COMMERCE DE GROS DE PRODUITS CHIMIQUES":[
                                    "COMMERCE DE GROS DE PRODUITS CHIMIQUES"
                                ],
                                "COMMERCE DE GROS D'AUTRES PRODUITS INTERMEDIAIRES":[
                                    "COMMERCE DE GROS D'AUTRES PRODUITS INTERMEDIAIRES"
                                ],
                                "COMMERCE DE GROS DE DECHETS ET DEBRIS":[
                                    "COMMERCE DE GROS DE DECHETS ET DEBRIS"
                                ]
                            },
                            "COMMERCE DE GROS D'EQUIPEMENTS INDUSTRIELS":{
                                "COMMERCE DE GROS DE MACHINES-OUTILS":[
                                    "COMMERCE DE GROS DE MACHINES-OUTILS"
                                ],
                                "COMMERCE DE GROS D'EQUIPEMENTS POUR LA CONSTRUCTION":[
                                    "COMMERCE DE GROS D'EQUIPEMENTS POUR LA CONSTRUCTION"
                                ],
                                "COMMERCE DE GROS DE MACHINES POUR L'INDUSTRIE TEXTILE ET L'HABILLEMENT":[
                                    "COMMERCE DE GROS DE MACHINES POUR L'INDUSTRIE TEXTILE ET L'HABILLEMENT"
                                ],
                                "COMMERCE DE GROS DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":[
                                    "COMMERCE DE GROS DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE"
                                ],
                                "COMMERCE DE GROS D'AUTRES EQUIPEMENTS INDUSTRIELS":[
                                    "COMMERCE DE GROS DE MATERIEL ELECTRIQUE ET ELECTRONIQUE",
                                    "COMMERCE DE GROS DE FOURNITURES ET EQUIPEMENTS INDUSTRIELS DIVERS"
                                ],
                                "COMMERCE DE GROS DE MATERIEL AGRICOLE":[
                                    "COMMERCE DE GROS DE MATERIEL AGRICOLE"
                                ]
                            },
                            "AUTRES COMMERCES DE GROS":{
                                "AUTRES COMMERCES DE GROS":[
                                    "AUTRES COMMERCES DE GROS"
                                ]
                            }
                        },
                        "COMMERCE DE DETAIL ET REPARATION D'ARTICLES DOMESTIQUES":{
                            "COMMERCE DE DETAIL EN MAGASIN NON SPECIALISE":{
                                "COMMERCE DE DETAIL EN MAGASIN NON SPECIALISE A PREDOMINANCE ALIMENTAIRE":[
                                    "COMMERCE D'ALIMENTATION GENERALE",
                                    "SUPERETTES, SUPERMARCHES ET HYPERMARCHES",
                                    "AUTRES COMMERCES DE DETAIL EN MAGASIN NON SPECIALISE A PREDOMINANCE ALIMENTAIRE"
                                ],
                                "AUTRES COMMERCES DE DETAIL EN MAGASIN NON SPECIALISE SANS PREDOMINANCE ALIMENTAIRE":[
                                    "AUTRES COMMERCES DE DETAIL EN MAGASIN NON SPECIALISE SANS PREDOMINANCE ALIMENTAIRE"
                                ]
                            },
                            "COMMERCE DE DETAIL ALIMENTAIRE EN MAGASIN SPECIALISE":{
                                "COMMERCE DE DETAIL DE FRUITS ET LEGUMES":[
                                    "COMMERCE DE DETAIL DE FRUITS ET LEGUMES"
                                ],
                                "COMMERCE DE DETAIL DE VIANDES ET PRODUITS A BASE DE VIANDE":[
                                    "COMMERCE DE DETAIL DE VIANDES ET PRODUITS A BASE DE VIANDE"
                                ],
                                "COMMERCE DE DETAIL DE POISSONS, CRUSTACES ET MOLLUSQUES":[
                                    "COMMERCE DE DETAIL DE POISSONS, CRUSTACES ET MOLLUSQUES"
                                ],
                                "COMMERCE DE DETAIL DE PAIN, PATISSERIE ET CONFISERIE":[
                                    "COMMERCE DE DETAIL DE PAIN, PATISSERIE ET CONFISERIE"
                                ],
                                "COMMERCE DE DETAIL DE BOISSONS":[
                                    "COMMERCE DE DETAIL DE BOISSONS"
                                ],
                                "COMMERCE DE DETAIL DE TABAC":[
                                    "COMMERCE DE DETAIL DE TABAC"
                                ],
                                "AUTRES COMMERCES DE DETAIL ALIMENTAIRES EN MAGASIN SPECIALISE":[
                                    "COMMERCE DE DETAIL DE PRODUITS LAITIERS",
                                    "COMMERCES DE DETAIL DE GRAINS, LEGUMES SECS ET PRODUITS D'EPICERIE"
                                ]
                            },
                            "COMMERCE DE DETAIL DE PRODUITS PHARMACEUTIQUES ET DE PARFUMERIE":{
                                "COMMERCE DE DETAIL DE PRODUITS PHARMACEUTIQUES":[
                                    "COMMERCE DE DETAIL DE PRODUITS PHARMACEUTIQUES"
                                ],
                                "COMMERCE DE DETAIL D'ARTICLES MEDICAUX ET ORTHOPEDIQUES":[
                                    "COMMERCE DE DETAIL D'ARTICLES MEDICAUX ET ORTHOPEDIQUES"
                                ],
                                "COMMERCE DE DETAIL DE PARFUMERIE ET DE PRODUITS DE BEAUTE":[
                                    "COMMERCE DE DETAIL DE PARFUMERIE ET DE PRODUITS DE BEAUTE"
                                ]
                            },
                            "AUTRES COMMERCES DE DETAIL EN MAGASIN SPECIALISE":{
                                "COMMERCE DE DETAIL DE TEXTILES":[
                                    "COMMERCE DE DETAIL DE TEXTILES"
                                ],
                                "COMMERCE DE DETAIL D'HABILLEMENT":[
                                    "COMMERCE DE DETAIL D'HABILLEMENT"
                                ],
                                "COMMERCE DE DETAIL DE CHAUSSURES ET D'ARTICLES EN CUIR":[
                                    "COMMERCE DE DETAIL DE LA CHAUSSURE",
                                    "COMMERCE DE DETAIL DE MAROQUINERIE ET D'ARTICLES DE VOYAGE",
                                    "COMMERCE DE DETAIL EN PRODUITS DIVERS DE L'ARTISANAT"
                                ],
                                "COMMERCE DE DETAIL DE MEUBLES ET D'EQUIPEMENTS DU FOYER":[
                                    "COMMERCE DE DETAIL DE MEUBLES ET D'EQUIPEMENTS DU FOYER"
                                ],
                                "COMMERCE DE DETAIL D'APPAREILS ELECTROMENAGERS ET DE RADIOTELEVISION":[
                                    "COMMERCE DE DETAIL D'APPAREILS ELECTROMENAGERS ET DE RADIOTELEVISION"
                                ],
                                "COMMERCE DE DETAIL DE QUINCAILLERIE, PEINTURES ET VERRES":[
                                    "COMMERCE DE DETAIL DE QUINCAILLERIE, PEINTURES ET VERRES"
                                ],
                                "COMMERCE DE DETAIL DE LIVRES, JOURNAUX ET PAPETERIE":[
                                    "COMMERCE DE DETAIL DE LIVRES, JOURNAUX ET PAPETERIE"
                                ],
                                "COMMERCES DE DETAIL SPECIALISES DIVERS":[
                                    "COMMERCE DE DETAIL D'OPTIQUE ET DE PHOTOGRAPHIE",
                                    "COMMERCE DE DETAIL D'HORLOGERIE ET DE BIJOUTERIE",
                                    "COMMERCE DE DETAIL DE FLEURS",
                                    "COMMERCE DE DETAIL DE CHARBONS ET COMBUSTIBLES",
                                    "COMMERCES DE DETAIL DIVERS EN MAGASIN SPECIALISE"
                                ]
                            },
                            "COMMERCE DE DETAIL DE BIENS D'OCCASION EN MAGASIN":{
                                "COMMERCE DE DETAIL DE BIENS D'OCCASION EN MAGASIN":[
                                    "COMMERCE DE DETAIL DE BIENS D'OCCASION EN MAGASIN"
                                ]
                            },
                            "COMMERCE DE DETAIL HORS MAGASIN":{
                                "VENTE PAR CORRESPONDANCE":[
                                    "VENTE PAR CORRESPONDANCE"
                                ],
                                "COMMERCE DE DETAIL SUR EVENTAIRES ET MARCHES":[
                                    "COMMERCE AMBULANT DE VIANDES ET ANIMAUX VIVANTS",
                                    "COMMERCE AMBULANT DE FRUITS ET LEGUMES",
                                    "COMMERCE AMBULANT DE GRAINS, LEGUMES SECS ET PRODUITS D'EPICERIE",
                                    "COMMERCE AMBULANT DE TEXTILES, HABILLEMENT ET CUIRS",
                                    "COMMERCE AMBULANT DE QUINCAILLERIE ET D'EQUIPEMENTS MENAGERS"
                                ],
                                "AUTRES COMMERCES DE DETAIL HORS MAGASIN":[
                                    "AUTRES COMMERCES DE DETAIL HORS MAGASIN"
                                ]
                            },
                            "REPARATION D'ARTICLES PERSONNELS ET DOMESTIQUES":{
                                "REPARATION DE CHAUSSURES ET D'ARTICLES EN CUIR":[
                                    "REPARATION DE CHAUSSURES ET D'ARTICLES EN CUIR"
                                ],
                                "REPARATION D'APPAREILS ELECTRIQUES A USAGE DOMESTIQUE":[
                                    "REPARATION DE MATERIEL ELECTRONIQUE GRAND PUBLIC",
                                    "REPARATION D'ARTICLES ELECTRIQUES A USAGE DOMESTIQUE"
                                ],
                                "REPARATION DE MONTRES, HORLOGES ET BIJOUX":[
                                    "REPARATION DE MONTRES, HORLOGES ET BIJOUX"
                                ],
                                "REPARATION D'ARTICLES PERSONNELS ET DOMESTIQUES N.C.A.":[
                                    "REPARATION D'ARTICLES PERSONNELS ET DOMESTIQUES N.C.A."
                                ]
                            }
                        }
                    }
                },
                "HOTELS ET RESTAURANTS":{
                    "HOTELS ET RESTAURANTS":{
                        "HOTELS ET RESTAURANTS":{
                            "HOTELS":{
                                "HOTELS AVEC RESTAURANT":[
                                    "HOTELS AVEC RESTAURANT"
                                ],
                                "HOTELS SANS RESTAURANT":[
                                    "HOTELS DE TOURISME SANS RESTAURANT",
                                    "HOTELS NON CLASSES"
                                ]
                            },
                            "AUTRES MOYENS D'HEBERGEMENT DE COURTE DUREE":{
                                "AUBERGES DE JEUNESSE ET REFUGES":[
                                    "AUBERGES DE JEUNESSE ET REFUGES"
                                ],
                                "EXPLOITATION DE TERRAINS DE CAMPING":[
                                    "EXPLOITATION DE TERRAINS DE CAMPING"
                                ],
                                "MOYENS D'HEBERGEMENT DIVERS":[
                                    "AUTRE HEBERGEMENT TOURISTIQUE",
                                    "HEBERGEMENT COLLECTIF NON TOURISTIQUE"
                                ]
                            },
                            "RESTAURANTS":{
                                "RESTAURANTS":[
                                    "RESTAURATION DE TYPE TRADITIONNEL",
                                    "RESTAURATION SIMPLIFIEE"
                                ]
                            },
                            "CAFES ET DEBITS DE BOISSONS":{
                                "CAFES":[
                                    "CAFES",
                                    "DEBITS DE BOISSONS ALCOOLISEES"
                                ]
                            },
                            "CANTINES ET TRAITEURS":{
                                "CANTINES ET RESTAURANTS D'ENTREPRISES":[
                                    "CANTINES ET RESTAURANTS D'ENTREPRISES"
                                ],
                                "TRAITEURS":[
                                    "TRAITEURS"
                                ]
                            }
                        }
                    }
                },
                "TRANSPORTS ET COMMUNICATIONS":{
                    "TRANSPORTS ET COMMUNICATIONS":{
                        "TRANSPORTS TERRESTRES":{
                            "TRANSPORTS FERROVIAIRES":{
                                "TRANSPORTS FERROVIAIRES":[
                                    "TRANSPORTS FERROVIAIRES"
                                ]
                            },
                            "TRANSPORTS URBAINS ET ROUTIERS":{
                                "TRANSPORTS REGULIERS DE VOYAGEURS":[
                                    "TRANSPORTS URBAINS DE VOYAGEURS",
                                    "AUTRES TRANSPORTS ROUTIERS REGULIERS DE VOYAGEURS"
                                ],
                                "TRANSPORT DE VOYAGEURS PAR TAXIS ET PAR LOUAGES":[
                                    "TRANSPORT DE VOYAGEURS PAR TAXIS ET PAR LOUAGES"
                                ],
                                "AUTRES TRANSPORTS ROUTIERS DE VOYAGEURS":[
                                    "AUTRES TRANSPORTS ROUTIERS DE VOYAGEURS"
                                ],
                                "TRANSPORTS ROUTIERS DE MARCHANDISES":[
                                    "TRANSPORTS ROUTIERS DE MARCHANDISES",
                                    "DEMENAGEMENT",
                                    "LOCATION DE CAMIONS AVEC CONDUCTEUR"
                                ]
                            },
                            "TRANSPORTS PAR CONDUITES":{
                                "TRANSPORTS PAR CONDUITES":[
                                    "TRANSPORTS PAR CONDUITES"
                                ]
                            }
                        },
                        "TRANSPORTS MARITIMES":{
                            "TRANSPORTS MARITIMES ET COTIERS":{
                                "TRANSPORTS MARITIMES ET COTIERS":[
                                    "TRANSPORTS MARITIMES",
                                    "TRANSPORTS COTIERS (PAR BAC)."
                                ]
                            }
                        },
                        "TRANSPORTS AERIENS":{
                            "TRANSPORTS AERIENS REGULIERS":{
                                "TRANSPORTS AERIENS REGULIERS":[
                                    "TRANSPORTS AERIENS REGULIERS"
                                ]
                            },
                            "TRANSPORTS AERIENS NON REGULIERS":{
                                "TRANSPORTS AERIENS NON REGULIERS":[
                                    "TRANSPORTS AERIENS NON REGULIERS"
                                ]
                            },
                            "TRANSPORTS SPATIAUX":{
                                "TRANSPORTS SPATIAUX":[
                                    "TRANSPORTS SPATIAUX"
                                ]
                            }
                        },
                        "SERVICES AUXILIAIRES DES TRANSPORTS":{
                            "MANUTENTION ET ENTREPOSAGE":{
                                "MANUTENTION":[
                                    "MANUTENTION"
                                ],
                                "ENTREPOSAGE":[
                                    "ENTREPOSAGE FRIGORIFIQUE",
                                    "ENTREPOSAGE NON FRIGORIFIQUE"
                                ]
                            },
                            "GESTION D'INFRASTRUCTURES DE TRANSPORTS":{
                                "GESTION D'INFRASTRUCTURES DES TRANSPORTS TERRESTRES":[
                                    "GESTION D'INFRASTRUCTURES DES TRANSPORTS TERRESTRES"
                                ],
                                "SERVICES ANNEXES DES TRANSPORTS MARITIMES":[
                                    "SERVICES ANNEXES DES TRANSPORTS MARITIMES"
                                ],
                                "SERVICES ANNEXES DES TRANSPORTS AERIENS":[
                                    "SERVICES ANNEXES DES TRANSPORTS AERIENS"
                                ]
                            },
                            "AGENCES DE VOYAGES":{
                                "AGENCES DE VOYAGES":[
                                    "AGENCES DE VOYAGES"
                                ]
                            },
                            "ORGANISATION DU TRANSPORT DE FRET":{
                                "ORGANISATION DU TRANSPORT DE FRET":[
                                    "ORGANISATION DU TRANSPORT DE FRET"
                                ]
                            }
                        },
                        "POSTES ET TELECOMMUNICATIONS":{
                            "ACTIVITES DE POSTE ET DE COURRIER":{
                                "POSTES NATIONALES":[
                                    "POSTES NATIONALES"
                                ],
                                "AUTRES ACTIVITES DE COURRIER":[
                                    "AUTRES ACTIVITES DE COURRIER"
                                ]
                            },
                            "TELECOMMUNICATIONS":{
                                "TELECOMMUNICATIONS":[
                                    "TELECOMMUNICATIONS NATIONALES",
                                    "AUTRES ACTIVITES DE TELECOMMUNICATIONS"
                                ]
                            }
                        }
                    }
                },
                "ACTIVITES FINANCIERES":{
                    "ACTIVITES FINANCIERES":{
                        "INTERMEDIATION FINANCIERE":{
                            "INTERMEDIATION MONETAIRE":{
                                "BANQUE CENTRALE":[
                                    "BANQUE CENTRALE"
                                ],
                                "AUTRES INTERMEDIATIONS MONETAIRES":[
                                    "AUTRES INTERMEDIATIONS MONETAIRES"
                                ]
                            },
                            "AUTRES INTERMEDIATIONS FINANCIERES":{
                                "CREDIT-BAIL":[
                                    "CREDIT-BAIL"
                                ],
                                "DISTRIBUTION DE CREDIT":[
                                    "DISTRIBUTION DE CREDIT"
                                ],
                                "AUTRES INTERMEDIATIONS FINANCIERES N.C.A.":[
                                    "AUTRES INTERMEDIATIONS FINANCIERES N.C.A."
                                ]
                            }
                        },
                        "ASSURANCE":{
                            "ASSURANCE":{
                                "ASSURANCE-VIE ET CAPITALISATION":[
                                    "ASSURANCE-VIE ET CAPITALISATION"
                                ],
                                "CAISSES DE RETRAITE":[
                                    "CAISSES DE RETRAITE"
                                ],
                                "AUTRES ASSURANCES":[
                                    "AUTRES ASSURANCES"
                                ]
                            }
                        },
                        "AUXILIAIRES FINANCIERS ET D'ASSURANCE":{
                            "AUXILIAIRES FINANCIERS":{
                                "ADMINISTRATION DE MARCHES FINANCIERS":[
                                    "ADMINISTRATION DE MARCHES FINANCIERS"
                                ],
                                "GESTION DE PORTEFEUILLES":[
                                    "GESTION DE PORTEFEUILLES"
                                ],
                                "AUTRES AUXILIAIRES FINANCIERS":[
                                    "AUTRES AUXILIAIRES FINANCIERS"
                                ]
                            },
                            "AUXILIAIRES D'ASSURANCE":{
                                "AUXILIAIRES D'ASSURANCE":[
                                    "AUXILIAIRES D'ASSURANCE"
                                ]
                            }
                        }
                    }
                },
                "IMMOBILIER, LOCATIONS ET SERVICES AUX ENTREPRISES":{
                    "IMMOBILIER, LOCATIONS ET SERVICES AUX ENTREPRISES":{
                        "ACTIVITES IMMOBILIERES":{
                            "ACTIVITES IMMOBILIERES POUR COMPTE PROPRE":{
                                "PROMOTION IMMOBILIERE":[
                                    "PROMOTION IMMOBILIERE"
                                ],
                                "MARCHANDS DE BIENS IMMOBILIERS POUR COMPTE PROPRE":[
                                    "MARCHANDS DE BIENS IMMOBILIERS POUR COMPTE PROPRE"
                                ]
                            },
                            "LOCATION DE BIENS IMMOBILIERS":{
                                "LOCATION DE BIENS IMMOBILIERS":[
                                    "LOCATION DE LOGEMENTS",
                                    "LOCATION DE TERRAINS",
                                    "LOCATION D'AUTRES BIENS IMMOBILIERS"
                                ]
                            },
                            "ACTIVITES IMMOBILIERES POUR COMPTE DE TIERS":{
                                "AGENCES IMMOBILIERES":[
                                    "AGENCES IMMOBILIERES"
                                ],
                                "ADMINISTRATION DE BIENS IMMOBILIERS":[
                                    "ADMINISTRATION DE BIENS IMMOBILIERS"
                                ]
                            }
                        },
                        "LOCATION SANS OPERATEUR":{
                            "LOCATION DE VEHICULES AUTOMOBILES":{
                                "LOCATION DE VEHICULES AUTOMOBILES":[
                                    "LOCATION DE VEHICULES AUTOMOBILES"
                                ]
                            },
                            "LOCATION D'AUTRES MATERIELS DE TRANSPORT":{
                                "LOCATION D'AUTRES MATERIELS DE TRANSPORT TERRESTRE":[
                                    "LOCATION D'AUTRES MATERIELS DE TRANSPORT TERRESTRE"
                                ],
                                "LOCATION DE MATERIELS DE TRANSPORT MARITIME":[
                                    "LOCATION DE MATERIELS DE TRANSPORT MARITIME"
                                ],
                                "LOCATION DE MATERIELS DE TRANSPORT AERIEN":[
                                    "LOCATION DE MATERIELS DE TRANSPORT AERIEN"
                                ]
                            },
                            "LOCATION DE MACHINES ET EQUIPEMENTS":{
                                "LOCATION DE MATERIEL AGRICOLE":[
                                    "LOCATION DE MATERIEL AGRICOLE"
                                ],
                                "LOCATION DE MACHINES ET EQUIPEMENTS POUR LA CONSTRUCTION":[
                                    "LOCATION DE MACHINES ET EQUIPEMENTS POUR LA CONSTRUCTION"
                                ],
                                "LOCATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":[
                                    "LOCATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE"
                                ],
                                "LOCATION DE MACHINES ET EQUIPEMENTS DIVERS":[
                                    "LOCATION DE MACHINES ET EQUIPEMENTS DIVERS"
                                ]
                            },
                            "LOCATION DE BIENS PERSONNELS ET DOMESTIQUES":{
                                "LOCATION DE BIENS PERSONNELS ET DOMESTIQUES":[
                                    "LOCATION DE BIENS PERSONNELS ET DOMESTIQUES"
                                ]
                            }
                        },
                        "ACTIVITES INFORMATIQUES":{
                            "CONSEIL EN SYSTEMES INFORMATIQUES":{
                                "CONSEIL EN SYSTEMES INFORMATIQUES":[
                                    "CONSEIL EN SYSTEMES INFORMATIQUES"
                                ]
                            },
                            "REALISATION DE LOGICIELS":{
                                "REALISATION DE LOGICIELS":[
                                    "REALISATION DE LOGICIELS"
                                ]
                            },
                            "TRAITEMENT DE DONNEES":{
                                "TRAITEMENT DE DONNEES":[
                                    "TRAITEMENT DE DONNEES"
                                ]
                            },
                            "ACTIVITES DE BANQUES DE DONNEES":{
                                "ACTIVITES DE BANQUES DE DONNEES":[
                                    "ACTIVITES DE BANQUES DE DONNEES"
                                ]
                            },
                            "ENTRETIEN ET REPARATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":{
                                "ENTRETIEN ET REPARATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE":[
                                    "ENTRETIEN ET REPARATION DE MACHINES DE BUREAU ET DE MATERIEL INFORMATIQUE"
                                ]
                            },
                            "AUTRES ACTIVITES RATTACHEES A L'INFORMATIQUE":{
                                "AUTRES ACTIVITES RATTACHEES A L'INFORMATIQUE":[
                                    "AUTRES ACTIVITES RATTACHEES A L'INFORMATIQUE"
                                ]
                            }
                        },
                        "RECHERCHE ET DEVELOPPEMENT":{
                            "RECHERCHE-DEVELOPPEMENT EN SCIENCES PHYSIQUES ET NATURELLES":{
                                "RECHERCHE-DEVELOPPEMENT EN SCIENCES PHYSIQUES ET NATURELLES":[
                                    "RECHERCHE-DEVELOPPEMENT EN SCIENCES PHYSIQUES ET NATURELLES"
                                ]
                            },
                            "RECHERCHE-DEVELOPPEMENT EN SCIENCES HUMAINES ET SOCIALES":{
                                "RECHERCHE-DEVELOPPEMENT EN SCIENCES HUMAINES ET SOCIALES":[
                                    "RECHERCHE-DEVELOPPEMENT EN SCIENCES HUMAINES ET SOCIALES"
                                ]
                            }
                        },
                        "SERVICES FOURNIS PRINCIPALEMENT AUX ENTREPRISES":{
                            "ACTIVITES JURIDIQUES, COMPTABLES ET DE CONSEIL DE GESTION":{
                                "ACTIVITES JURIDIQUES":[
                                    "ACTIVITES JURIDIQUES"
                                ],
                                "ACTIVITES COMPTABLES ET D'AUDIT, CONSEIL FISCAL":[
                                    "ACTIVITES COMPTABLES ET D'AUDIT, CONSEIL FISCAL"
                                ],
                                "ETUDES DE MARCHE ET SONDAGES":[
                                    "ETUDES DE MARCHE ET SONDAGES"
                                ],
                                "CONSEIL POUR LES AFFAIRES ET LA GESTION":[
                                    "CONSEIL POUR LES AFFAIRES ET LA GESTION"
                                ],
                                "ADMINISTRATION D'ENTREPRISES":[
                                    "ADMINISTRATION D'ENTREPRISES"
                                ]
                            },
                            "ACTIVITES D'ARCHITECTURE ET D'INGENIERIE":{
                                "ACTIVITES D'ARCHITECTURE ET D'INGENIERIE":[
                                    "ACTIVITES D'ARCHITECTURE",
                                    "METREURS, GEOMETRES",
                                    "INGENIERIE, ETUDES TECHNIQUES"
                                ]
                            },
                            "ACTIVITES DE CONTROLE ET ANALYSES TECHNIQUES":{
                                "ACTIVITES DE CONTROLE ET ANALYSES TECHNIQUES":[
                                    "CONTROLE TECHNIQUE AUTOMOBILE",
                                    "ANALYSES, ESSAIS ET INSPECTIONS TECHNIQUES"
                                ]
                            },
                            "PUBLICITE":{
                                "PUBLICITE":[
                                    "PUBLICITE"
                                ]
                            },
                            "SELECTION ET FOURNITURE DE PERSONNEL":{
                                "SELECTION ET FOURNITURE DE PERSONNEL":[
                                    "SELECTION ET FOURNITURE DE PERSONNEL (RECHERCHE ET PLACEMENT DE PERSONNEL)"
                                ]
                            },
                            "ENQUETES ET SECURITE":{
                                "ENQUETES ET SECURITE":[
                                    "ENQUETES ET SECURITE"
                                ]
                            },
                            "ACTIVITES DE NETTOYAGE":{
                                "ACTIVITES DE NETTOYAGE":[
                                    "ACTIVITES DE NETTOYAGE"
                                ]
                            },
                            "SERVICES DIVERS FOURNIS PRINCIPALEMENT AUX ENTREPRISES":{
                                "ACTIVITES PHOTOGRAPHIQUES":[
                                    "ACTIVITES PHOTOGRAPHIQUES"
                                ],
                                "CONDITIONNEMENT A FA?ON":[
                                    "CONDITIONNEMENT A FA?ON"
                                ],
                                "SECRETARIAT, TRADUCTION ET ROUTAGE":[
                                    "SECRETARIAT, TRADUCTION ET ROUTAGE"
                                ],
                                "AUTRES SERVICES AUX ENTREPRISES N.C.A.":[
                                    "ORGANISATION DE FOIRES ET SALONS",
                                    "SERVICES ANNEXES A LA PRODUCTION"
                                ]
                            }
                        }
                    }
                },
                "ADMINISTRATION PUBLIQUE":{
                    "ADMINISTRATION PUBLIQUE":{
                        "ADMINISTRATION PUBLIQUE":{
                            "ADMINISTRATION GENERALE, ECONOMIQUE ET SOCIALE":{
                                "ADMINISTRATION PUBLIQUE GENERALE":[
                                    "ADMINISTRATION PUBLIQUE CENTRALE",
                                    "ADMINISTRATION DES COLLECTIVITES LOCALES"
                                ],
                                "TUTELLE DES ACTIVITES SOCIALES":[
                                    "TUTELLE DES ACTIVITES SOCIALES"
                                ],
                                "TUTELLE DES ACTIVITES ECONOMIQUES":[
                                    "TUTELLE DES ACTIVITES ECONOMIQUES"
                                ],
                                "ACTIVITES DE SOUTIEN AUX ADMINISTRATIONS":[
                                    "ACTIVITES DE SOUTIEN AUX ADMINISTRATIONS"
                                ]
                            },
                            "SERVICES DE PREROGATIVE PUBLIQUE":{
                                "AFFAIRES ETRANGERES":[
                                    "AFFAIRES ETRANGERES"
                                ],
                                "DEFENSE":[
                                    "DEFENSE"
                                ],
                                "JUSTICE":[
                                    "JUSTICE"
                                ],
                                "POLICE":[
                                    "POLICE"
                                ],
                                "PROTECTION CIVILE":[
                                    "PROTECTION CIVILE"
                                ]
                            },
                            "SECURITE SOCIALE OBLIGATOIRE":{
                                "SECURITE SOCIALE OBLIGATOIRE":[    
                                    "SECURITE SOCIALE OBLIGATOIRE"
                                ]
                            }
                        }
                    }
                },
                "EDUCATION":{
                    "EDUCATION":{
                        "EDUCATION":{
                            "ENSEIGNEMENT PRESCOLAIRE ET PRIMAIRE":{
                                "ENSEIGNEMENT PRESCOLAIRE ET PRIMAIRE":[
                                    "ENSEIGNEMENT PRESCOLAIRE",
                                    "ENSEIGNEMENT PRIMAIRE"
                                ]
                            },
                            "ENSEIGNEMENT SECONDAIRE ET FORMATION PROFESSIONNELLE":{
                                "ENSEIGNEMENT SECONDAIRE":[
                                    "ENSEIGNEMENT SECONDAIRE (COLLEGE - 1ER CYCLE)",
                                    "ENSEIGNEMENT SECONDAIRE (LYCEE - 2EME CYCLE)"
                                ],
                                "FORMATION PROFESSIONNELLE":[
                                    "FORMATION PROFESSIONNELLE"
                                ]
                            },
                            "ENSEIGNEMENT SUPERIEUR":{
                                "ENSEIGNEMENT SUPERIEUR":[
                                    "ENSEIGNEMENT SUPERIEUR"
                                ]
                            },
                            "FORMATION PERMANENTE ET AUTRES ACTIVITES D'ENSEIGNEMENT":{
                                "ECOLES DE CONDUITE":[
                                    "ECOLES DE CONDUITE"
                                ],
                                "FORMATION PERMANENTE ET ENSEIGNEMENTS DIVERS":[
                                    "FORMATION PERMANENTE ET ENSEIGNEMENTS DIVERS"
                                ]
                            }
                        }
                    }
                },
                "SANTE ET ACTION SOCIALE":{
                    "SANTE ET ACTION SOCIALE":{
                        "SANTE ET ACTION SOCIALE":{                         
                            "ACTIVITES POUR LA SANTE HUMAINE":{
                                "ACTIVITES HOSPITALIERES":[
                                    "ACTIVITES HOSPITALIERES"
                                ],
                                "PRATIQUE MEDICALE":[
                                    "PRATIQUE MEDICALE"
                                ],
                                "PRATIQUE DENTAIRE":[
                                    "PRATIQUE DENTAIRE"
                                ],
                                "AUTRES ACTIVITES POUR LA SANTE HUMAINE":[
                                    "ACTIVITES DES AUXILIAIRES MEDICAUX",
                                    "SOINS HORS D'UN CADRE REGLEMENTE",
                                    "AMBULANCES",
                                    "LABORATOIRES D'ANALYSES MEDICALES",
                                    "CENTRES DE COLLECTE ET BANQUES D'ORGANES"
                                ]
                            },
                            "ACTIVITES VETERINAIRES":{
                                "ACTIVITES VETERINAIRES":[
                                    "ACTIVITES VETERINAIRES"
                                ]
                            },
                            "ACTION SOCIALE":{
                                "ACTION SOCIALE AVEC HEBERGEMENT":[
                                    "ACTION SOCIALE AVEC HEBERGEMENT"
                                ],
                                "ACTION SOCIALE SANS HEBERGEMENT":[
                                    "CRECHES ET GARDERIES D'ENFANTS",
                                    "AUTRES FORMES D'ACTION SOCIALE"
                                ]
                            }
                        }
                    }
                },
                "SERVICES COLLECTIFS, SOCIAUX ET PERSONNELS":{
                    "SERVICES COLLECTIFS, SOCIAUX ET PERSONNELS":{
                        "ASSAINISSEMENT, VOIRIE ET GESTION DES DECHETS":{
                            "ASSAINISSEMENT, VOIRIE ET GESTION DES DECHETS":{
                                "ASSAINISSEMENT, VOIRIE ET GESTION DES DECHETS":[
                                    "EPURATION DES EAUX USEES",
                                    "ENLEVEMENT ET TRAITEMENT DES DECHETS"
                                ]
                            }   
                        },
                        "ACTIVITES ASSOCIATIVES":{
                            "ORGANISATIONS ECONOMIQUES":{
                                "ORGANISATIONS PATRONALES ET CONSULAIRES":[
                                    "ORGANISATIONS PATRONALES ET CONSULAIRES"
                                ],
                                "ORGANISATIONS PROFESSIONNELLES":[
                                    "ORGANISATIONS PROFESSIONNELLES"
                                ]
                            },
                            "SYNDICATS DE SALARIES":{
                                "SYNDICATS DE SALARIES":[
                                    "SYNDICATS DE SALARIES"
                                ]
                            },
                            "AUTRES ORGANISATIONS ASSOCIATIVES":{
                                "ORGANISATIONS RELIGIEUSES":[
                                    "ORGANISATIONS RELIGIEUSES"
                                ],
                                "ORGANISATIONS POLITIQUES":[
                                    "ORGANISATIONS POLITIQUES"
                                ],
                                "ORGANISATIONS ASSOCIATIVES N.C.A.":[
                                    "ORGANISATIONS ASSOCIATIVES N.C.A."
                                ]
                            }
                        },
                        "ACTIVITES RECREATIVES, CULTURELLES ET SPORTIVES":{
                            "ACTIVITES CINEMATOGRAPHIQUES ET VIDEO":{
                                "PRODUCTION DE FILMS":[
                                    "PRODUCTION DE FILMS"
                                ],
                                "DISTRIBUTION DE FILMS":[
                                    "DISTRIBUTION DE FILMS CINEMATOGRAPHIQUES",
                                    "EDITION ET DISTRIBUTION VIDEO"
                                ],
                                "PROJECTION DE FILMS CINEMATOGRAPHIQUES":[
                                    "PROJECTION DE FILMS CINEMATOGRAPHIQUES"
                                ]
                            },
                            "ACTIVITES DE RADIO ET DE TELEVISION":{
                                "ACTIVITES DE RADIO ET DE TELEVISION":[
                                    "ACTIVITES DE RADIO ET DE TELEVISION"
                                ]
                            },
                            "AUTRES ACTIVITES DE SPECTACLE":{
                                "ART DRAMATIQUE ET MUSIQUE":[
                                    "ART DRAMATIQUE ET MUSIQUE"
                                ],
                                "GESTION DE SALLES DE SPECTACLE":[
                                    "GESTION DE SALLES DE SPECTACLE"
                                ],
                                "MANEGES FORAINS ET PARCS D'ATTRACTIONS":[
                                    "MANEGES FORAINS ET PARCS D'ATTRACTIONS"
                                ],
                                "ACTIVITES DIVERSES DE SPECTACLE":[
                                    "ACTIVITES DIVERSES DE SPECTACLE"
                                ]
                            },
                            "AGENCES DE PRESSE":{
                                "AGENCES DE PRESSE":[
                                    "AGENCES DE PRESSE"
                                ]
                            },
                            "AUTRES ACTIVITES CULTURELLES":{
                                "GESTION DES BIBLIOTHEQUES ET ARCHIVES PUBLIQUES":[
                                    "GESTION DES BIBLIOTHEQUES ET ARCHIVES PUBLIQUES"
                                ],
                                "GESTION DES MUSEES ET PRESERVATION DES SITES ET MONUMENTS HISTORIQUES":[
                                    "GESTION DES MUSEES ET PRESERVATION DES SITES ET MONUMENTS HISTORIQUES"
                                ],
                                "GESTION DES JARDINS BOTANIQUES, ZOOLOGIQUES ET DES RESERVES NATURELLES":[
                                    "GESTION DES JARDINS BOTANIQUES, ZOOLOGIQUES ET DES RESERVES NATURELLES"
                                ]
                            },
                            "ACTIVITES LIEES AU SPORT":{
                                "GESTION D'INSTALLATIONS SPORTIVES":[
                                    "GESTION D'INSTALLATIONS SPORTIVES"
                                ],
                                "AUTRES ACTIVITES SPORTIVES":[
                                    "AUTRES ACTIVITES SPORTIVES"
                                ]
                            },
                            "ACTIVITES RECREATIVES":{
                                "JEUX DE HASARD ET D'ARGENT":[
                                    "JEUX DE HASARD ET D'ARGENT"
                                ],
                                "AUTRES ACTIVITES RECREATIVES":[
                                    "AUTRES ACTIVITES RECREATIVES"
                                ]
                            }
                        },
                        "SERVICES PERSONNELS":{
                            "SERVICES PERSONNELS":{
                                "BLANCHISSERIE - TEINTURERIE":[
                                    "BLANCHISSERIE - TEINTURERIE"
                                ],
                                "COIFFURE ET SOINS DE BEAUTE":[
                                    "COIFFURE ET SOINS DE BEAUTE"
                                ],
                                "SERVICES FUNERAIRES":[
                                    "SERVICES FUNERAIRES"
                                ],
                                "ENTRETIEN CORPOREL":[
                                    "ACTIVITES THERMALES ET DE THALASSOTHERAPIE",
                                    "BAINS ET AUTRES SOINS CORPORELS"
                                ],
                                "AUTRES SERVICES PERSONNELS":[
                                    "AUTRES SERVICES PERSONNELS"
                                ]
                            }
                        }
                    }
                },
                "SERVICES DOMESTIQUES":{
                    "SERVICES DOMESTIQUES":{
                        "SERVICES DOMESTIQUES":{
                            "SERVICES DOMESTIQUES":{
                                "SERVICES DOMESTIQUES":[
                                    "SERVICES DOMESTIQUES"
                                ]
                            }
                        }
                    }
                },
                "ORGANISMES EXTRA-TERRITORIAUX":{
                    "ORGANISMES EXTRA-TERRITORIAUX":{
                        "ORGANISMES EXTRA-TERRITORIAUX":{
                            "ORGANISMES EXTRA-TERRITORIAUX":{
                                "ORGANISMES EXTRA-TERRITORIAUX":[
                                    "ORGANISMES EXTRA-TERRITORIAUX"
                                ]
                            }
                        }
                    }
                }   
            }
        }

    }
}
</script>

<style>

</style>
